{
  "addons.addonList": "Eklenti Listesi",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Bu bağlantıdan API anahtarınızı oluşturun ve alın",
  "addons.ambientWeatherDescription": "Ortam Hava İstasyonları (WS-5000, WS-2000, WS-2902C, ...)",
  "addons.apiKey": "API Anahtarı",
  "addons.applicationKey": "Uygulama anahtarı",
  "addons.connect": "Bağlan",
  "addons.davisApiSecret": "API sırrı",
  "addons.davisApiV2Key": "V2 API Anahtarı",
  "addons.davisDescription": "Davis Hava Durumu İstasyonları (Vantage Vue, Vantage Pro2, ...)",
  "addons.davisRetrieveApiKey": "V2 API anahtarlarınızı bu bağlantıdan alın",
  "addons.disconnect": "Bağlantıyı kes",
  "addons.ecowittCreateAndRetrieveKeys": "Bu bağlantıdan hem API anahtarı hem de bir uygulama anahtarı oluşturun ve alın",
  "addons.ecowittDescription": "Ecowitt, profesyonel WiFi hava durumu istasyonu, kablosuz kapalı dış mekan termometreleri, nem monitörleri, yüksek hassasiyetli yağmur göstergeleri, hava kalitesi monitörleri ve daha fazlasını sağlar.",
  "addons.helpLink": "{provider} nasıl bağlanır",
  "addons.myAcuriteAccountOnHold": "Hesabınız beklemeye alındı. Hesabınızı yeniden bağlamak için lütfen şifrenizi girin",
  "addons.myAcuriteDescription": "Acurite, Kuzey Amerika'daki 1 numaralı hava istasyonu markasıdır. Zaman, sıcaklık ve hava teknolojisinde bir lider olarak Acurite, iç mekan ve dış ortamınız hakkında ayrıntılı bilgi sağlar, böylece gününüzü güvenle planlayabilirsiniz.",
  "addons.myAcuriteEnterCredentials": "Acurite hesabımı SmartMixin ile bağlamak için Acurite kimlik bilgilerinizi girin",
  "addons.netatmoEnergy": "Netatmo enerjisi",
  "addons.netatmoEnergyDescription": "Evinizin sıcaklığını, yatağınızdan veya dünyanın diğer tarafından değiştirmek için netatmo termostatınızı kullanın.",
  "addons.netatmoThermostat": "Netatmo termostat",
  "addons.netatmoWeather": "Netatmo hava durumu",
  "addons.netatmoWeatherDescription": "Evde kişisel hava istasyonunuz",
  "addons.or": "veya",
  "addons.providerAccountDisconnected": "Hava durumu hizmetinize olan bağlantı süresi doldu. Veri güncellemelerini sürdürmek için lütfen yeniden bağlanın.",
  "addons.reconnect": "Yeniden bağlan",
  "addons.weatherflowCreateToken": "Bu bağlantıdan jetonunuzu oluşturun ve alın",
  "addons.weatherflowTempestDescription": "Dahili rüzgâr ölçer, yağmur göstergesi ile tempest hava sistemi",
  "addons.wundergroundApiKey": "API Anahtarı",
  "addons.wundergroundDescription": "Weather Underground, hava istasyonları ve hava kalitesi monitörleri gibi çevre sensörlerinden veri birleştiren küresel bir insan topluluğudur, böylece tutkularınızı güçlendirmek için ihtiyacınız olan zengin, hiperlokal verileri sağlayabiliriz",
  "addons.wundergroundRetrieveApiKey": "API anahtarınızı bu bağlantıdan alın",
  "addons.wundergroundStationId": "İstasyon kimliği",
  "airQuality.adviceActivityGood": "Dışarıda aktif olmak için ideal bir gün",
  "airQuality.adviceActivityHazardous": "Dışarıda her türlü fiziksel aktiviteden kaçının",
  "airQuality.adviceActivityLabel": "Fiziksel aktivite",
  "airQuality.adviceActivityModerate": "Dışarıda aktif olmak için iyi bir gün",
  "airQuality.adviceActivitySensitive": "Dış mekân aktivitelerini daha kısa ve daha az yoğun tutmayı düşünün",
  "airQuality.adviceActivityUnhealthy": "Uzun veya yoğun aktiviteleri azaltın ve daha sık ara verin",
  "airQuality.adviceActivityVeryUnhealthy": "Uzun veya yoğun aktivitelerden kaçının; bunları iç mekâna taşımayı düşünün",
  "airQuality.adviceGroupsGood": "Özel bir önlem gerekmiyor",
  "airQuality.adviceGroupsHazardous": "İç mekânda kalın ve aktiviteyi düşük tutun",
  "airQuality.adviceGroupsLabel": "Hassas gruplar",
  "airQuality.adviceGroupsModerate": "Özellikle hassas kişiler: aktiviteleri daha kısa ve daha az yoğun tutun",
  "airQuality.adviceGroupsSensitive": "Dış mekân aktivitelerini daha kısa ve daha az yoğun tutun, daha sık ara verin",
  "airQuality.adviceGroupsUnhealthy": "Uzun veya yoğun dış mekân aktivitelerinden kaçının; bunları iç mekâna taşımayı düşünün",
  "airQuality.adviceGroupsVeryUnhealthy": "Dışarıda her türlü fiziksel aktiviteden kaçının; erteleyin veya iç mekâna taşıyın",
  "airQuality.adviceTimingLabel": "Ne zaman dışarı çıkmalı",
  "airQuality.adviceTimingMorning": "Tercihen sabah — ozon o saatlerde daha düşük",
  "airQuality.airQuality": "Hava kalitesi",
  "airQuality.airQualityIndex": "Hava Kalitesi Endeksi",
  "airQuality.aqiForecast": "Hava kalitesi tahmini",
  "airQuality.co": "Karbon monoksit",
  "airQuality.dailyForecast": "Günlük Tahmin",
  "airQuality.details": "Detaylar",
  "airQuality.dominantPollutant": "Baskın kirletici",
  "airQuality.expectedPeak": "Beklenen zirve",
  "airQuality.good": "İyi",
  "airQuality.goodDescription": "Hava kalitesi tatmin edici olarak kabul edilir ve hava kirliliği çok az risk oluşturur veya hiç yoktur",
  "airQuality.hazardous": "Tehlikeli",
  "airQuality.hazardousDescription": "Sağlık Uyarısı: Herkes daha ciddi sağlık etkileri yaşayabilir",
  "airQuality.indoorAirQuality": "İç mekan hava kalitesi",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Ilıman",
  "airQuality.moderateDescription": "Hava kalitesi kabul edilebilir; Bununla birlikte, bazı kirleticiler için, hava kirliliğine alışılmadık derecede duyarlı olan çok az sayıda insan için ılımlı bir sağlık sorunu olabilir.",
  "airQuality.no2": "Azot dioksit",
  "airQuality.noForecastForLocation": "Bu konum için hava kalitesi tahmini mevcut değil.",
  "airQuality.now": "Şimdi",
  "airQuality.o3": "Ozon",
  "airQuality.pm10": "Çapı 10 μm veya daha az olan parçacıklar",
  "airQuality.pm25": "Çapı 2.5 μm veya daha az olan parçacıklar",
  "airQuality.pollutants": "Kirleticiler",
  "airQuality.ppb": "ppb",
  "airQuality.recommendations": "Öneriler",
  "airQuality.sensitiveUnhealthy": "Hassas insanlar için sağlıksız",
  "airQuality.sensitiveUnhealthyDescription": "Hassas grupların üyeleri sağlık etkileri yaşayabilir. Genel halkın etkilenmesi muhtemel değildir.",
  "airQuality.so2": "Kükürt dioksit",
  "airQuality.subIndex": "AQI alt indeksi",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Endeksi anlamak",
  "airQuality.unhealthy": "Sağlıksız",
  "airQuality.unhealthyDescription": "Herkes sağlık etkileri yaşamaya başlayabilir; Hassas grupların üyeleri daha ciddi sağlık etkileri yaşayabilir",
  "airQuality.veryUnhealthy": "Çok sağlıksız",
  "airQuality.veryUnhealthyDezscription": "Acil durum koşullarının sağlık uyarıları. Tüm nüfusun etkilenmesi daha olasıdır.",
  "alerts.addAlert": "Uyarı Ekle",
  "alerts.addCondition": "Durum ekle",
  "alerts.alertAdded": "Uyarı başarıyla eklendi",
  "alerts.alertAuthorizationNotice": "Uyarılar yalnızca SmartMixin'e bildirimleri görüntüleme yetkisi verirseniz çalışır",
  "alerts.alertDeleted": "Uyarı başarıyla silindi",
  "alerts.alertEdited": "Uyarı başarıyla değiştirildi",
  "alerts.alertName": "Uyarı Adı",
  "alerts.alertWhen": "Ne zaman uyarılmak istiyorum:",
  "alerts.aqiGreaterThan": "AQI daha büyük",
  "alerts.aqiGreaterThanThreshold": "AQI {value}{unit} eşiğinden daha büyük",
  "alerts.aqiLessThan": "AQI daha az",
  "alerts.aqiLessThanThreshold": "AQI {value}{unit} eşiğinden daha az",
  "alerts.atLeastOneCondition": "En az bir durum eklemeniz gerekiyor",
  "alerts.co2GreaterThan": "CO2 daha büyük",
  "alerts.co2GreaterThanThreshold": "CO2 {value}{unit} eşiğinden daha büyük",
  "alerts.co2LessThan": "CO2 daha az",
  "alerts.co2LessThanThreshold": "CO2 {value}{unit} eşiğinden daha az",
  "alerts.conditions": "Koşullar",
  "alerts.createAlert": "Uyarı Oluştur",
  "alerts.dailyPrecipitationGreaterThan": "Günlük yağış şundan fazla",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Günlük yağış {value}{unit} eşiğini aştı",
  "alerts.deleteAlert": "Uyarıyı sil",
  "alerts.editAlert": "Uyarı düzenle",
  "alerts.editCondition": "Düzenleme Durum",
  "alerts.gustSpeedGreaterThan": "Rüzgâr hamlesi hızı daha büyük",
  "alerts.gustSpeedGreaterThanThreshold": "Rüzgâr hamlesi hızı {value}{unit} eşiğinden daha büyük",
  "alerts.gustSpeedLessThan": "Rüzgâr hamlesi hızı daha az",
  "alerts.gustSpeedLessThanThreshold": "Rüzgâr hamlesi hızı {value}{unit} eşiğinden daha az",
  "alerts.heatIndexGreaterThan": "Isı indeksi daha büyük",
  "alerts.heatIndexGreaterThanThreshold": "{value}{unit} eşiğinden büyük Isı indeksi",
  "alerts.heatIndexLessThan": "Isı indeksi daha az",
  "alerts.heatIndexLessThanThreshold": "{value}{unit} eşiğinden daha az Isı indeksi",
  "alerts.humidexGreaterThan": "Humidex daha büyük",
  "alerts.humidexGreaterThanThreshold": "{value}{unit} eşiğinden büyük Humidex",
  "alerts.humidexLessThan": "Humidex daha az",
  "alerts.humidexLessThanThreshold": "{value}{unit} eşiğinden daha az Humidex",
  "alerts.humidityGreaterThan": "Nemden daha büyük",
  "alerts.humidityGreaterThanThreshold": "Nem {value}{unit} eşiğinden daha büyük",
  "alerts.humidityLessThan": "Nemden daha az",
  "alerts.humidityLessThanThreshold": "Nem {value}{unit} eşiğinden daha az",
  "alerts.inProgress": "Devam etmekte",
  "alerts.myAlerts": "Uyarılarım",
  "alerts.noConfiguredAlert": "Henüz yapılandırılmış herhangi bir uyarınız yok, bir tane eklemeye başlayın",
  "alerts.noiseGreaterThan": "Gürültü daha büyük",
  "alerts.noiseGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük gürültü",
  "alerts.noiseLessThan": "Gürültü daha az",
  "alerts.noiseLessThanThreshold": "{value}{unit} eşiğinden daha az gürültü",
  "alerts.noteOnConditions": "Aşağıdaki koşulların tümü doğrulandığında uyarının tetiklendiğini unutmayın",
  "alerts.noTriggerHistory": "Bu uyarı henüz tetiklenmedi.",
  "alerts.pm10GreaterThan": "PM 10 daha büyük",
  "alerts.pm10GreaterThanThreshold": "PM 10 {value}{unit} eşiğinden daha büyük",
  "alerts.pm10LessThan": "PM 10'dan daha az",
  "alerts.pm10LessThanThreshold": "PM 10 {value}{unit} eşiğinden daha az",
  "alerts.pm1GreaterThan": "PM 1 daha büyük",
  "alerts.pm1GreaterThanThreshold": "PM 1 {value}{unit} eşiğinden daha büyük",
  "alerts.pm1LessThan": "PM 1'den daha az",
  "alerts.pm1LessThanThreshold": "PM 1 {value}{unit} eşiğinden daha az",
  "alerts.pm2p5GreaterThan": "PM 2.5 daha büyük",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 {value}{unit} eşiğinden daha büyük",
  "alerts.pm2p5LessThan": "PM 2.5 daha az",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 {value}{unit} eşiğinden daha az",
  "alerts.postStormSummary": "Yağış sonrası özeti",
  "alerts.postStormSynopsisHelper": "Her yağış sona erdiğinde özet bildirimi alırsınız.",
  "alerts.postStormSynopsisSoleCondition": "Fırtına sonrası özeti diğer koşullarla birleştirilemez.",
  "alerts.precipitationGreaterThan": "Saatlik yağış şundan fazla",
  "alerts.precipitationGreaterThanThreshold": "Saatlik yağış {value}{unit} eşiğini aştı",
  "alerts.pressureGreaterThan": "Basınç daha büyük",
  "alerts.pressureGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük basınç",
  "alerts.pressureLessThan": "Basınç daha az",
  "alerts.pressureLessThanThreshold": "{value}{unit} eşiğinden daha az basınç",
  "alerts.rainRateGreaterThan": "Yağış yoğunluğu şundan fazla",
  "alerts.rainRateGreaterThanThreshold": "Yağış yoğunluğu {value}{unit} eşiğini aştı",
  "alerts.solarRadiationGreaterThan": "Güneş radyasyonu daha büyük",
  "alerts.solarRadiationGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük güneş radyasyonu",
  "alerts.solarRadiationLessThan": "Güneş radyasyonu daha az",
  "alerts.solarRadiationLessThanThreshold": "{value}{unit} eşiğinden daha az güneş radyasyonu",
  "alerts.stormChartUnavailable": "Bu yağış için yağmur geçmişi mevcut değil.",
  "alerts.stormDetail": "Yağış özeti",
  "alerts.stormDuration": "Süre",
  "alerts.stormEnd": "Bitiş",
  "alerts.stormPeakRate": "En yüksek yağış şiddeti",
  "alerts.stormStart": "Başlangıç",
  "alerts.stormTotal": "Toplam yağış",
  "alerts.temperatureGreaterThan": "Sıcaklık daha büyük",
  "alerts.temperatureGreaterThanThreshold": "{value}{unit} eşiğinden büyük sıcaklık",
  "alerts.temperatureLessThan": "Sıcaklık daha az",
  "alerts.temperatureLessThanThreshold": "{value}{unit} eşiğinden daha az sıcaklık",
  "alerts.thswGreaterThan": "THSW daha büyük",
  "alerts.thswGreaterThanThreshold": "{value}{unit} eşiğinden büyük THSW",
  "alerts.thswLessThan": "THSW daha az",
  "alerts.thswLessThanThreshold": "{value}{unit} eşiğinden daha az THSW",
  "alerts.thwGreaterThan": "THW daha büyük",
  "alerts.thwGreaterThanThreshold": "{value}{unit} eşiğinden büyük THW",
  "alerts.thwLessThan": "THW daha az",
  "alerts.thwLessThanThreshold": "{value}{unit} eşiğinden daha az THW",
  "alerts.triggerHistory": "Uyarı geçmişi",
  "alerts.uvGreaterThan": "UV endeksi daha büyük",
  "alerts.uvGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük UV dizin",
  "alerts.uvLessThan": "UV endeksi daha az",
  "alerts.uvLessThanThreshold": "{value}{unit} eşiğinden daha az UV endeksi",
  "alerts.visibilityGreaterThanThreshold": "{value}{unit} eşiğinden daha büyük görünürlük",
  "alerts.visibilityLessThanThreshold": "{value}{unit} eşiğinden daha az görünürlük",
  "alerts.visiblityGreaterThan": "Görünürlük daha büyük",
  "alerts.visiblityLessThan": "Görünürlük",
  "alerts.whichMeasure": "Hangi önlem için uyarılmak istersiniz?",
  "alerts.whichModule": "Hangi modül için uyarılmak istersiniz?",
  "alerts.windChillGreaterThan": "Rüzgâr Soğutma daha büyük",
  "alerts.windChillGreaterThanThreshold": "{value}{unit} eşiğinden büyük Rüzgâr Soğutma",
  "alerts.windChillLessThan": "Rüzgâr Soğutma daha az",
  "alerts.windChillLessThanThreshold": "{value}{unit} eşiğinden daha az Rüzgâr Soğutma",
  "alerts.windSpeedGreaterThan": "Rüzgâr hızı daha büyük",
  "alerts.windSpeedGreaterThanThreshold": "Rüzgâr hızı {value}{unit} eşiğinden daha büyük",
  "alerts.windSpeedLessThan": "Rüzgâr hızı daha az",
  "alerts.windSpeedLessThanThreshold": "Rüzgâr hızı {value}{unit} eşiğinden daha az",
  "astral.aboveHorizonAllDay": "Tüm gün ufkun üzerinde",
  "astral.aboveTheHorizon": "ufkun üzerinde",
  "astral.apparentSize": "Açısal çap",
  "astral.apparentSizeAcross": "{size} çapında",
  "astral.astronomicalDawn": "Astronomik şafak",
  "astral.astronomicalDusk": "Astronomik alacakaranlık",
  "astral.astronomicalSunPhase": "Astronomik {sunPhase}",
  "astral.belowHorizonAllDay": "Tüm gün ufkun altında",
  "astral.belowHorizonSince": "{time} saatinden beri ufkun altında",
  "astral.belowHorizonSinceOn": "{day} {time} saatinden beri ufkun altında",
  "astral.brightAllNight": "Tüm gece aydınlık — hiç tam karanlık olmuyor",
  "astral.brightestMoment": "En aydınlık an",
  "astral.civilDawn": "Sivil şafak",
  "astral.civilDusk": "Sivil alacakaranlık",
  "astral.civilSunPhase": "Sivil {sunPhase}",
  "astral.darkSkyBetween": "Karanlık gökyüzü {from} → {to}",
  "astral.darkSkyWindow": "Karanlık gökyüzü {from} → {to} · Aysız {duration}",
  "astral.dawn": "Şafak",
  "astral.dayLength": "Gün uzunluğu",
  "astral.daylightThroughTheYear": "Yıl boyunca gün uzunluğu",
  "astral.dayOfCycle": "{day} / {total} gün",
  "astral.doesNotOccurToday": "Bugün gerçekleşmiyor",
  "astral.domeHint": "Gece boyunca ilerlemek için sürükleyin",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.dusk": "Alacakaranlık",
  "astral.earliestSunrise": "En erken gündoğumu",
  "astral.earliestSunset": "En erken günbatımı",
  "astral.equinox": "Ekinoks",
  "astral.equinoxIn": "{days} gün sonra ekinoks",
  "astral.evening": "Akşam",
  "astral.exactPhaseAt": "Tam olarak {time}",
  "astral.firstQuarter": "İlk dördün",
  "astral.firstSunriseIn": "{days} gün sonra ilk gündoğumu",
  "astral.firstSunsetIn": "{days} gün sonra ilk günbatımı",
  "astral.fullMoon": "Dolunay",
  "astral.goldenHourBegins": "Altın saat başlıyor",
  "astral.goldenHourEnds": "Altın saat bitiyor",
  "astral.highestPoint": "En yüksek nokta",
  "astral.inDays": "{days} gün sonra",
  "astral.lastQuarter": "Son dördün",
  "astral.latestSunrise": "En geç gündoğumu",
  "astral.latestSunset": "En geç günbatımı",
  "astral.litShort": "Aydınl.",
  "astral.longestDay": "En uzun gün",
  "astral.lowestPoint": "En alçak nokta",
  "astral.maxAltitudeShort": "Maks.",
  "astral.midday": "Öğle",
  "astral.midnightSun": "Gece yarısı güneşi",
  "astral.midnightSunPeriod": "Gece yarısı güneşi",
  "astral.milestoneFootnotePolar": "Burada güneş yılda {days, plural, one {# gün} other {# gün}} ne doğar ne batar; bu yüzden liste olağan en erken/en geç doğuş ve batış yerine bunun ne zaman olduğunu gösterir.",
  "astral.milestoneFootnoteTemperate": "En erken gün batımı ve en geç gün doğumu en kısa güne denk gelmez — bu iki tarihi gündönümü değil, zaman denklemi belirler.",
  "astral.moon": "Ay",
  "astral.moonAltitude": "Yükseklik",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Uzaklık",
  "astral.moonlessFor": "Aysız {duration}",
  "astral.moonPhases": "Ay evreleri",
  "astral.moonrise": "Ay doğuşu",
  "astral.moonset": "Ay batışı",
  "astral.moonUpAllNight": "Ay tüm gece ufkun üzerinde",
  "astral.moonWashesOutNight": "Ay {rise} ile {set} arasında ufkun üzerinde ve tüm geceyi aydınlatıyor",
  "astral.morning": "Sabah",
  "astral.nauticalDawn": "Denizcilik şafağı",
  "astral.nauticalDusk": "Denizcilik alacakaranlığı",
  "astral.nauticalSunPhase": "Denizcilik {sunPhase}",
  "astral.newMoon": "Yeni ay",
  "astral.nextDay": "+1 gün",
  "astral.nextProperlyDarkNight": "Sonraki gerçekten karanlık gece",
  "astral.nextRise": "sonraki ay doğumu {time}",
  "astral.nextRiseOn": "sonraki ay doğumu {day} {time}",
  "astral.nextSevenNights": "Önümüzdeki yedi gece",
  "astral.noAstronomicalDarknessTonight": "Bu gece astronomik karanlık yok",
  "astral.noDarkNightAhead": "Önümüzdeki iki hafta içinde yok",
  "astral.noon": "Öğlen",
  "astral.noSunriseToday": "Bugün gün doğumu yok",
  "astral.nowAtBearing": "şimdi {altitude} · azimut {direction}",
  "astral.observing": "Gözlem",
  "astral.ofDaylightLeft": "gün ışığı kaldı",
  "astral.overTheNextThreeWeeks": "önümüzdeki 3 hafta içinde",
  "astral.percentLit": "{percent} aydınlık",
  "astral.polarNight": "Kutup gecesi",
  "astral.polarNightPeriod": "Kutup gecesi",
  "astral.remainingDaylight": "Kalan gün ışığı",
  "astral.rightNow": "Şu an",
  "astral.riseShort": "Doğuş",
  "astral.setShort": "Batış",
  "astral.shortestDay": "En kısa gün",
  "astral.solarNoon": "Gerçek öğle",
  "astral.solstice": "Gündönümü",
  "astral.sunBelowHorizon": "Güneş ufkun {degrees}° altında",
  "astral.sunEvents": "Güneş olayları",
  "astral.sunNeverDarkEnough": "Güneş hiç ufkun 18° altına inmiyor",
  "astral.sunNeverSets": "Güneş batmıyor",
  "astral.sunrise": "Gündoğumu",
  "astral.sunriseAndSunset": "Gün doğumu ve gün batımı",
  "astral.sunriseAt": "Gün doğumu {time}",
  "astral.sunset": "Gün batımı",
  "astral.sunsetAt": "Gün batımı {time}",
  "astral.thisYearAtNorth": "Bu yıl {degrees}° kuzey enleminde",
  "astral.thisYearAtSouth": "Bu yıl {degrees}° güney enleminde",
  "astral.tonight": "Bu gece",
  "astral.totalDaylight": "Toplam gün ışığı",
  "astral.twilightAllNight": "Tüm gece alacakaranlık — hiç tam karanlık olmuyor",
  "astral.upFor": "{duration} ufkun üzerinde",
  "astral.usableLight": "Kullanılabilir ışık",
  "astral.vsAverage": "ortalamaya göre {percent}",
  "astral.vsYesterday": "düne göre",
  "astral.waningCrescent": "Küçülen hilal",
  "astral.waningGibbous": "Küçülen şişkin ay",
  "astral.waxingCrescent": "Büyüyen hilal",
  "astral.waxingGibbous": "Büyüyen şişkin ay",
  "astral.whereToLook": "Nereye bakmalı",
  "astral.withoutTheMoon": "Aysız {duration}",
  "auth.alreadyHaveAccount": "Zaten bir hesabınız var mı?",
  "auth.authContainerTagline": "Kişisel hava durumu panonuz. İstasyonlarınızı bağlayın ve gerçek zamanlı verilere parmaklarınızın ucunda ulaşın.",
  "auth.backToLogin": "Giriş sayfasına dön",
  "auth.catchPhrase": "Hava Durumu İstihbarat Platformu",
  "auth.checkYourEmail": "E-postanızı kontrol edin",
  "auth.continueWithApple": "Apple ile devam et",
  "auth.continueWithFacebook": "Facebook ile devam et",
  "auth.continueWithGoogle": "Google ile devam et",
  "auth.email": "E -posta adresi",
  "auth.emailRequiredLoginFacebook": "E -posta izni gereklidir.",
  "auth.emailVerification": "E -posta Doğrulama",
  "auth.emailVerificationFailure": "E -posta doğrulamanızda bir sorun meydana geldi.",
  "auth.emailVerificationSuccess": "E -postanız başarıyla doğrulandı.",
  "auth.firstName": "İlk adı",
  "auth.forgotPassword": "Şifrenizi mi unuttunuz?",
  "auth.forgotPasswordSubtitle": "E-postanızı girin, size şifrenizi sıfırlamak için bir bağlantı göndereceğiz.",
  "auth.lastName": "Soy isim",
  "auth.login": "Giriş yap",
  "auth.loginSubtitle": "Tekrar hoş geldiniz! Lütfen bilgilerinizi girin.",
  "auth.loginToSmartMixinDescription": "Hesabınıza erişmek için SmartMixin kimlik bilgilerinizi girin.",
  "auth.logout": "Oturumu kapat",
  "auth.logoutConfirmation": "Oturumu kapatmak istediğinden emin misiniz?",
  "auth.noAccountYet": "Henüz bir hesabınız yok mu?",
  "auth.or": "veya",
  "auth.password": "Şifre",
  "auth.passwordAgain": "Tekrar şifre",
  "auth.passwordReset": "Parola Sıfırlama",
  "auth.passwordResetSuccess": "Şifreniz başarıyla güncellendi.",
  "auth.register": "Hesap oluştur",
  "auth.registerDescription": "Hava istasyonlarınızı bağlamak, hava durumu verilerini takip etmek ve güçlü analiz araçlarına erişmek için ücretsiz bir SmartMixin hesabı oluşturun.",
  "auth.registerSubtitle": "Başlamak için hesabınızı oluşturun.",
  "auth.registerSuccess": "Başarılı bir şekilde kayıt yaptırdınız! Size daha fazla talimat içeren {emailAddress} 'te bir doğrulama bağlantısı gönderdik.",
  "auth.restorePassword": "Şifre Geri Yükle",
  "auth.restorePasswordSuccess": "Size daha fazla talimat içeren {emailAddress} adresinden bir şifre sıfırlama bağlantısı gönderdik.",
  "auth.sendReset": "Sıfırlama talimatlarını gönderin",
  "auth.signInWithApple": "",
  "auth.socialAccount": "veya hesabınızı kullanın",
  "auth.staffVerificationCode": "Doğrulama kodu",
  "auth.staffVerificationExpiresIn": "Doğrulandı. {duration} sonra sona erecek.",
  "auth.staffVerificationInvalidCode": "Kod hatalı. Tekrar deneyin.",
  "auth.staffVerificationLoginAsStopped": "Login As durduruldu: devam etmek için Debug ekranında bir doğrulama kodu girin.",
  "auth.staffVerificationNotEnrolled": "Hesabınız için bir kimlik doğrulama uygulaması ayarlanmamış. Arka ofisin güvenlik ayarlarından bir tane ekleyin.",
  "auth.staffVerificationPrompt": "Login As ve kullanıcı aramasını kullanmak için kimlik doğrulama uygulamanızdaki 6 haneli kodu veya bir kurtarma kodunu girin.",
  "auth.staffVerificationSetupLink": "Kimlik doğrulama uygulaması ekle",
  "auth.staffVerificationSubmit": "Doğrula",
  "auth.staffVerificationTitle": "Personel doğrulaması",
  "auth.welcome": "Smartmixine hoş geldiniz",
  "auth.welcomeBack": "Tekrar hoşgeldiniz!",
  "calendar.april": "Nisan",
  "calendar.august": "Ağustos",
  "calendar.dateFormat": "Tarih biçimi",
  "calendar.day": "Gün",
  "calendar.december": "Aralık",
  "calendar.end": "Son",
  "calendar.february": "Şubat",
  "calendar.hours": "Saat",
  "calendar.hoursShort": "saat",
  "calendar.january": "Ocak",
  "calendar.july": "Temmuz",
  "calendar.june": "Haziran",
  "calendar.last24Hours": "Son 24 Saat",
  "calendar.last30Days": "Son 30 Gün",
  "calendar.last7Days": "Son 7 Gün",
  "calendar.march": "Mart",
  "calendar.max": "Maksimum",
  "calendar.may": "Mayıs",
  "calendar.month": "Ay",
  "calendar.months": "aylar",
  "calendar.november": "Kasım",
  "calendar.october": "Ekim",
  "calendar.oneDay": "1 gün",
  "calendar.oneHour": "1 saat",
  "calendar.oneMonth": "1 aylık",
  "calendar.oneWeek": "1 haftalık",
  "calendar.previous24Hours": "Önceki 24 Saat",
  "calendar.previous30Days": "Önceki 30 gün",
  "calendar.previous7Days": "Önceki 7 gün",
  "calendar.previousDay": "Önceki Gün",
  "calendar.previousMonth": "Önceki Ay",
  "calendar.previousWeek": "Önceki Hafta",
  "calendar.previousYear": "Önceki yıl",
  "calendar.sameDayLastYear": "Geçen yıl aynı gün",
  "calendar.sameMonthLastYear": "Geçen yıl aynı ay",
  "calendar.selectADate": "Bir Tarih Seçin",
  "calendar.selectAggregation": "Görüntülenen değeri seçin",
  "calendar.selectAMonth": "Bir Ay Seçin",
  "calendar.selectAYear": "Bir Yıl Seçin",
  "calendar.selectGranularity": "Bir tanecik seçin",
  "calendar.selectTimescale": "Bir Zaman Ölçeği Seçin",
  "calendar.september": "Eylül",
  "calendar.sixHours": "6 saat",
  "calendar.start": "Başlangıç",
  "calendar.thirtyMinutes": "30 dakika",
  "calendar.threeHours": "3 saat",
  "calendar.use24HourFormat": "24 saatlik format kullanın",
  "calendar.week": "Hafta",
  "calendar.year": "Yıl",
  "calendar.yesterday": "Dün",
  "common.accountDeleted": "Hesabınız başarıyla silindi.",
  "common.accountOnHold": "Hesap bağlantınızın süresi doldu. Veri güncellemelerini sürdürmek için lütfen yeniden bağlanın.",
  "common.add": "Ekle",
  "common.addAStation": "Bir İstasyon Ekle",
  "common.addToFavorites": "Favorilere ekle",
  "common.addYourOwnStation": "Kendi istasyonunuzu ekleyin",
  "common.afternoon": "Öğleden sonra",
  "common.alreadyPremium": "Zaten premium bir hesabınız var!",
  "common.alsoAvailableOn": "Şurada da mevcut:",
  "common.altitude": "Yükseklik",
  "common.analysis": "Analiz",
  "common.aroundMe": "Etrafımda",
  "common.articleCount": "{count} makale",
  "common.articleNotFound": "Makale Bulunamadı",
  "common.articleNotFoundDescription": "Aradığınız makale mevcut değil.",
  "common.average": "Ortalama",
  "common.averageOverThePeriod": "Dönem boyunca ortalama",
  "common.away": "Uzak",
  "common.back": "Geri",
  "common.backToHelpCenter": "Yardım Merkezine Dön",
  "common.backToHome": "Ana Sayfaya Dön",
  "common.bad": "Kötü",
  "common.batteryLevel": "Pil seviyesi",
  "common.bestValue": "En İyi Değer",
  "common.billingDetailsAndroid": "Ücretsiz deneme teklifi için, ücretsiz tanıtım süresinin süresi dolmadan 24 saat önce iptal ederseniz ücret alınmayacaktır. Deneme bittiğinde, SmartMixin aboneliğini Google Play hesap ayarlarınız aracılığıyla istediğiniz zaman iptal edebilirsiniz veya otomatik olarak yenilenir. Bu, yukarıdaki düğmede gösterilen başka bir ücretin tahsil edilmesinden kaçınmak için abonelik süresinin bitiminden 24 saat önce yapılmalıdır. Abonelik ödemeleri, satın alma işleminizin onaylanması ve her bir yenileme döneminin başlangıcında Google Play hesabınıza tahsil edilecektir.",
  "common.billingDetailsIos": "Ücretsiz deneme teklifi için, ücretsiz tanıtım süresinin süresi dolmadan 24 saat önce iptal ederseniz ücret alınmayacaktır. Deneme bittiğinde, SmartMixin aboneliğini App Store hesap ayarlarınız aracılığıyla istediğiniz zaman iptal edebilirsiniz veya otomatik olarak yenilenir. Bu, yukarıdaki düğmede gösterilen başka bir ücretin tahsil edilmesinden kaçınmak için abonelik süresinin bitiminden 24 saat önce yapılmalıdır. Abonelik ödemeleri, satın alma işleminizin onaylanması ve her bir yenileme döneminin başlangıcında App Store hesabınıza tahsil edilecektir.",
  "common.boilerOn": "Kazan",
  "common.browseByCategory": "Kategoriye göre göz at",
  "common.calendarView": "Takvim görünümü",
  "common.cancel": "İptal",
  "common.cannotBeEmpty": "Bu alan boş olamaz.",
  "common.cardDetails": "Kart Ayrıntıları",
  "common.categoryNotFound": "Kategori bulunamadı",
  "common.categoryNotFoundDescription": "Bu kategori mevcut değil veya makale içermiyor.",
  "common.charts": "Grafikler",
  "common.chartView": "Grafik Görünümü",
  "common.clearRecentLocations": "Tümünü temizle",
  "common.close": "Kapat",
  "common.co2Fresh": "Temiz",
  "common.co2GettingStale": "Ağırlaşıyor",
  "common.co2Stale": "Ağır",
  "common.comparison": "Karşılaştırma",
  "common.contactMe": "Benimle iletişime geçin",
  "common.currentDay": "Geçerli gün",
  "common.currentLocation": "Mevcut Konum",
  "common.currentObservations": "Mevcut gözlemler",
  "common.currentRainEvent": "Mevcut Yağmur Etkinliği",
  "common.currentRate": "Mevcut Oran",
  "common.currentWeatherConditions": "Mevcut Koşullar",
  "common.customizeComparisonMetrics": "Ölçümleri özelleştir",
  "common.customizeComparisonMetricsDescription": "Karşılaştırma ölçümlerinizi yeniden sıralamak için öğeleri sürükleyin. Ölçümleri göstermek veya gizlemek için göz simgesine dokunun.",
  "common.customizeDashboard": "Özelleştir",
  "common.customizeDashboardDescription": "Panelinizdeki sıralamayı değiştirmek için öğeleri sürükleyin. Bölümleri göstermek veya gizlemek için göz simgesine dokunun.",
  "common.customizedStationName": "Özelleştirilmiş İstasyon Adı",
  "common.dailyForecast": "Günlük Tahmin",
  "common.dashboard": "Gösterge paneli",
  "common.dayRangeExpected": "{value} bekleniyor ({time})",
  "common.dayRangeReached": "{value} ({time})",
  "common.dayRangeSteady": "Gün boyunca sabit {value}",
  "common.default": "Varsayılan",
  "common.defaultForecastModelChip": "Varsayılan · {name}",
  "common.delete": "Sil",
  "common.deleteAccount": "Hesabınızı Sil",
  "common.deleteAccountConfirmation": "Hesabınızı silmek istediğinizden emin misiniz? Bu eylem geri döndürülemez.",
  "common.deleteAccountDescription": "Bu eylem hesabınızı ve tüm bilgilerinizi siler. Geri dönüş yok.",
  "common.details": "Detaylar",
  "common.durationHours": "{hours} sa",
  "common.durationHoursMinutes": "{hours} sa {minutes} dk",
  "common.durationMinutes": "{minutes} dk",
  "common.durationMinutesSeconds": "{minutes} dk {seconds} sn",
  "common.durationSeconds": "{seconds} sn",
  "common.edit": "Düzenle",
  "common.editor": "Editör",
  "common.endTime": "Son zaman",
  "common.evening": "Akşam",
  "common.exitFullscreen": "Tam ekrandan çık",
  "common.exploreWeatherMap": "Hava Haritasını Keşfet",
  "common.favoriteLocations": "Favoriler",
  "common.favoriteLocationsEmpty": "En fazla 5 favori yer ekleyebilirsiniz.",
  "common.favoriteStations": "Favori İstasyonlar",
  "common.feedbackHelpsImprove": "Görüşleriniz yardım makalelerimizi geliştirmemize yardımcı oluyor.",
  "common.feedbackReasonNotAnswer": "Sorumu yanıtlamıyor",
  "common.feedbackReasonOutdated": "Bilgiler güncel değil",
  "common.feedbackReasonUnclear": "Talimatlar net değil",
  "common.feedbackWhatWentWrong": "Sorun neydi?",
  "common.filterStationDescription": "Güvenilmez önlemlerle istasyonları görüntülemeyin",
  "common.filterStations": "Filtre istasyonları",
  "common.filterStationSourceDescription": "Haritada görüntülemek istediğiniz istasyon sağlayıcılarını seçin",
  "common.findStationsNearYou": "Yakınınızdaki istasyonları bulun",
  "common.firmwareVersion": "Ürün yazılımı sürümü",
  "common.forecast": "Tahmin",
  "common.forecastAllModels": "Tüm modeller ({count})",
  "common.forecastComparisonDescription": "Birkaç kaynaktan tahmin model çıkışlarını kolayca karşılaştırın",
  "common.forecastFollowingPreferences": "Tercihlerinize göre",
  "common.forecastModelComparison": "Tahmin modeli karşılaştırması",
  "common.forecastModelCoverage": "Kapsama",
  "common.forecastModelDescription": "Açıklama",
  "common.forecastModelDescription_AROME": "Météo France'ın Batı Avrupa üzerinde 1,3 km çözünürlükte konveksiyonu çözen yüksek çözünürlüklü modeli. Fransa'daki kısa vadeli tahminler için sınıfının en iyisi; üç saatte bir güncellenir.",
  "common.forecastModelDescription_ARPEGE_EU": "Météo France'ın ARPEGE modelinin 10 km çözünürlükteki Avrupa yuvası. Avrupa üzerinde orta vadeli tahminler, günde dört kez güncellenir.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Météo France'ın 25 km çözünürlükte yaklaşık 4 güne kadar çalışan küresel sayısal hava tahmin modeli. Günde dört kez güncellenir.",
  "common.forecastModelDescription_DMI_DINI": "DMI'nin HARMONIE DINI modeli: kuzeybatı Avrupa — Danimarka, Benelüks, İrlanda, Birleşik Krallık ve İskandinavya — üzerinde 2 km çözünürlükte, 60 saate kadar çalışan, konveksiyona izin veren bir model, günde sekiz kez güncellenir. Değiştirilmiş DMI açık verilerini içerir (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Environment Canada'nın Küresel Deterministik Tahmin Sistemi: 15 km çözünürlükte 10 güne kadar çalışan dünya çapında orta vadeli model, günde iki kez güncellenir.",
  "common.forecastModelDescription_EC_HRDPS": "Environment Canada'nın Yüksek Çözünürlüklü Deterministik Tahmin Sistemi: Kanada ve kuzey ABD üzerinde 2,5 km çözünürlükte, 48 saate kadar çalışan, konveksiyona izin veren bir model, günde dört kez güncellenir.",
  "common.forecastModelDescription_EC_RDPS": "Environment Canada'nın Bölgesel Deterministik Tahmin Sistemi: Kuzey Amerika üzerinde 10 km çözünürlükte orta vadeli model, günde dört kez güncellenir.",
  "common.forecastModelDescription_ECMWF_HRES": "Avrupa Orta Vadeli Hava Tahminleri Merkezi'nin amiral gemisi yüksek çözünürlüklü modeli (IFS), dünyanın önde gelen küresel tahmin sistemi olarak kabul edilir. Tüm gezegeni 25 km çözünürlükle 15 güne kadar kapsar, günde dört kez güncellenir. Değiştirilmiş ECMWF açık verilerini içerir (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "NOAA'nın amiral gemisi orta vadeli küresel modeli. Tüm gezegeni 25 km çözünürlükte 16 güne kadar kapsar, günde dört kez güncellenir.",
  "common.forecastModelDescription_HRRR_CONUS": "NOAA'nın High-Resolution Rapid Refresh modeli: kıta ABD üzerinde 3 km çözünürlükte konveksiyonu çözen model, her saat güncellenir. Fırtınalar ve şiddetli hava koşullarının çok kısa vadeli tahminleri için en uygundur.",
  "common.forecastModelDescription_ICON": "DWD'nin 13 km çözünürlüğünde, tüm gezegeni 7,5 güne kadar kapsayan ve günde dört kez güncellenen küresel ICON modeli. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ItaliaMeteo'nun ARPAE ile birlikte işlettiği ICON-2I modeli: İtalya üzerinde 2,2 km çözünürlükte, 72 saate kadar çalışan, konveksiyona izin veren bir model, günde iki kez güncellenir. ItaliaMeteo açık verilerini içerir (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "MeteoSwiss'in ICON-CH1-EPS kontrol koşusu: Alpler üzerinde 1 km çözünürlükte, 33 saate kadar çalışan, konveksiyona izin veren bir model, üç saatte bir güncellenir.",
  "common.forecastModelDescription_ICON_CH2": "MeteoSwiss'in ICON-CH2-EPS kontrol koşusu: Alpler — İsviçre ve çevresindeki Alp bölgesi — üzerinde 2,1 km çözünürlükte, 120 saate kadar çalışan, konveksiyona izin veren bir model, günde dört kez güncellenir.",
  "common.forecastModelDescription_ICON_DE": "DWD'nin Almanya ve çevre ülkeler üzerinde 2,2 km çözünürlükte konveksiyonu çözen yüksek çözünürlüklü modeli. Kısa vadeli tahminler günde iki kez güncellenir. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "DWD'nin ICON modelinin Avrupa ve Kuzey Atlantik'i kapsayan 7 km çözünürlükteki Avrupa yuvası. Orta vadeli tahminler günde dört kez güncellenir. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Norveç Meteoroloji Enstitüsü'nün açık hava tahmini hizmeti, yüksek çözünürlüklü İskandinav modellerini ECMWF verileriyle birleştirerek 10 güne kadar dünya çapında tahminler sunar.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Fransız Antilleri (Guadeloupe, Martinique) üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Fransız Guyanası üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Yeni Kaledonya üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Fransız Polinezyası üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Réunion ve Mayotte üzerinde 2,5 km çözünürlükte AROME yuvası. Kısa vadeli tahminler günde dört kez güncellenir.",
  "common.forecastModelDescription_RRFS_CONUS": "NOAA'nın Rapid Refresh Forecast sistemi, kıta ABD üzerinde 3 km çözünürlükte. Günde sekiz kez yenilenen saatlik tahminler; dört ana koşuda 84 saate, diğerlerinde 18 saate kadar uzanır.",
  "common.forecastModelDescription_RRFS_NORTH_AMERICA": "NOAA'nın tüm Kuzey Amerika'yı 13 km çözünürlükte kapsayan Rapid Refresh Forecast sistemi. 84 saate kadar saatlik tahminler, günde dört kez yenilenir.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "SmartMixin'in amiral gemisi tahmini. Konumunuzdaki her saat için mevcut en iyi modeli seçiyoruz — genellikle bir tane varsa yüksek çözünürlüklü bir bölgesel model (Fransa'da AROME, Almanya'da ICON-D2, ABD'de HRRR, kıtanın her yerinde ARPEGE Europe…) ve başka yerlerde küresel bir modele geri dönüyoruz — sonra komşu kaynaklardan boşlukları dolduruyoruz. Sonuç, dünyanın herhangi bir yerini 14 güne kadar kapsayan tek bir kesintisiz tahmindir ve altta yatan modellerden herhangi biri güncellendiğinde otomatik olarak yenilenir.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Birden fazla sayısal hava tahmin modelini, Tempest hava istasyonu ağından gelen gözlemlerle birleştiren Weatherflow'un tescilli küresel tahmini. 10 günlük dünya çapında ufuk.",
  "common.forecastModelDetailTitle": "Tahmin modeli",
  "common.forecastModelScopeGlobal": "Küresel",
  "common.forecastModelScopeGlobalDescription": "Bu model tüm gezegeni kapsar.",
  "common.forecastModelScopeRegional": "Bölgesel",
  "common.forecastModelScopeRegionalDescription": "Bu model yalnızca belirli bir bölgeyi kapsar.",
  "common.forecastModelSpecifications": "Özellikler",
  "common.forecastNoPinLocation": "Hiçbir tercih edilen model bu konuma ulaşmıyor — “diğer her yerde” karar verir.",
  "common.forecastNoPinStation": "Hiçbir tercih edilen model bu istasyona ulaşmıyor — “diğer her yerde” karar verir.",
  "common.forecastNoPreferredModels": "Henüz tercih edilen model ayarlanmadı.",
  "common.forecastOverrideElsewhere": "Tercihleriniz diğer her yerde geçerlidir.",
  "common.forecastPickForLocation": "Ya da bu konum için birini seçin",
  "common.forecastPickForStation": "Ya da bu istasyon için birini seçin",
  "common.forecastPinWinsLocation": "{model} — bu konuma ulaşan ilk tercih edilen modeliniz.",
  "common.forecastPinWinsStation": "{model} — bu istasyona ulaşan ilk tercih edilen modeliniz.",
  "common.forecastServedNowHere": "Şu anda burada bu {model}",
  "common.forecastSetForLocation": "Bu konum için ayarlandı",
  "common.forecastSetForStation": "Bu istasyon için ayarlandı",
  "common.forecastSettingsRowSub": "Tercih edilen modeller ve diğer her yerde geçerli olan",
  "common.forecastSheetTitle": "Tahmin modeli",
  "common.forecastSources": "Tahmin Kaynakları",
  "common.forecastStopUsingHere": "Burada kullanma",
  "common.forecastUseForLocation": "Bu konum için {model} kullan",
  "common.forecastUseForStation": "Bu istasyon için {model} kullan",
  "common.forecastUsePreferred": "Tercih ettiğim modelleri kullan",
  "common.freeAccount": "Ücretsiz hesap",
  "common.freeSubscription": "Ücretsiz premium abonelik",
  "common.freeTrialForPeriod": "{period} günleri için ücretsiz deneme",
  "common.frequency": "Sıklık",
  "common.full": "Tam dolu",
  "common.fullscreen": "Tam ekran",
  "common.getStartedFree": "Ücretsiz Başla",
  "common.getUnlimitedAccess": "Sınırsız erişim:",
  "common.good": "İyi",
  "common.hail": "Dolu",
  "common.help": "Yardım",
  "common.helpCategoryAccount": "Hesap",
  "common.helpCategoryBilling": "Faturalandırma",
  "common.helpCategoryForecast": "Tahminler",
  "common.helpCategoryGettingStarted": "Başlarken",
  "common.helpCategoryProviders": "Sağlayıcılar",
  "common.helpCategoryStations": "İstasyonlar",
  "common.helpCategoryTroubleshooting": "Sorun Giderme",
  "common.helpCenter": "Yardım Merkezi",
  "common.helpCenterDescription": "Sık sorulan sorulara yanıtlar bulun ve SmartMixin'den en iyi şekilde nasıl yararlanacağınızı öğrenin.",
  "common.hg": "Donma koruyucusu",
  "common.hidden": "Gizli",
  "common.hiddenSensors": "Gizli sensörler",
  "common.hiddenStations": "Gizli İstasyonlar",
  "common.hiddenStationsDescription": "Yanındaki göz simgesine dokunarak bir istasyonu tekrar gösterebilirsiniz.",
  "common.high": "Yüksek",
  "common.home": "Ev",
  "common.homeConnectService": "Hava durumu istasyonunuz var mı? Servisinizi bağlayın",
  "common.homeInformation": "Ev bilgileri",
  "common.homeIntroduction": "SmartMixin özelliklerinin tadını çıkarmak için harici hesaplarınızı bağlamaya başlayın.",
  "common.homeName": "Ev adı",
  "common.homeSubtitle": "Hava durumunuz, hepsi tek bir yerde",
  "common.horizon": "Ufuk",
  "common.horizonValue": "{value} saatlerine kadar",
  "common.hour": "Saat",
  "common.iDontKnowYet": "Henüz bilmiyorum",
  "common.indoor": "Kapalı",
  "common.lastRainEvent": "Son Yağmur Etkinliği",
  "common.lastSeen": "son görülme {time}",
  "common.lastUpdate": "Son Güncelleme",
  "common.legendHeavy": "Yoğun",
  "common.legendLight": "Hafif",
  "common.legendLightningHelp": "Renk, son {minutes} dakikadaki her yıldırımın yaşını gösterir — en yeniler beyaz, en eskiler koyu kırmızı.",
  "common.legendNewest": "En yeni",
  "common.legendOldest": "En eski",
  "common.legendStationsHelp": "İşaretçi rengi seçili ölçümün değerini yansıtır.",
  "common.lightningDataAttribution": "Yıldırım verileri: Blitzortung.org",
  "common.lightningStrikes": "Yıldırım düşmeleri",
  "common.lightningStrikesDescription": "Yıldırım düşmelerini haritada gerçek zamanlı göster",
  "common.linkToSection": "Bu bölüme bağlantı",
  "common.loading": "Yükleme",
  "common.location": "Konum",
  "common.locationAddedToFavorites": "Favorilere yer eklendi",
  "common.locationNotGranted": "Konum izni verilmez. Lütfen cihaz ayarlarındaki konumunuza erişim sağlayın.",
  "common.locationRemovedFromFavorites": "Konum favorilerden kaldırıldı",
  "common.locations": "Yerler",
  "common.low": "Düşük",
  "common.manage": "Yönet",
  "common.manageAccount": "Hesabı Yönetin",
  "common.manageMySubscription": "Aboneliğimi yönetin",
  "common.manageSensors": "Sensörleri yönet",
  "common.manageSensorsDescription": "Sensörleri yeniden sıralamak için öğeleri sürükleyin. Sensörleri göstermek veya gizlemek için göz simgesine dokunun. Yeniden adlandırmak için bir isme dokunun.",
  "common.manualBoost": "Manuel destek",
  "common.manualSetpointUntil": "Manuel ayar noktası",
  "common.mapLayers": "Harita katmanları",
  "common.mapLegend": "Harita göstergesi",
  "common.maxFavoriteLocationsReached": "Sadece en fazla 5 favori yere sahip olabilirsiniz. Birini eklemek için bir tane çıkarın.",
  "common.maximum": "Maksimum",
  "common.maxOverThePeriod": "Dönem boyunca maksimum",
  "common.measureToDisplay": "Görüntülemek için ölçüm",
  "common.medium": "Orta",
  "common.meshSize": "Izgara boyutu",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} dk okuma",
  "common.modifyFavoriteStations": "Favori istasyonları değiştirin",
  "common.modifyFavoriteStationsDescription": "En sevdiğiniz istasyonları sürükleyerek yeniden sıralayabilirsiniz. Bunları listeden de kaldırabilirsiniz.",
  "common.moduleCount": "{count, plural, one {# modül} other {# modül}}",
  "common.moduleType": "Modül Türü",
  "common.monthTotal": "Ay toplam",
  "common.more": "Daha",
  "common.moreInformation": "Daha Fazla Bilgi",
  "common.morning": "Sabah",
  "common.myLocation": "Konumum",
  "common.nearbyWeatherStations": "Yakın hava istasyonları",
  "common.next": "Sonraki",
  "common.nextHours": "Sonraki Saatler",
  "common.night": "Gece",
  "common.no": "Hayır",
  "common.noAccountNeeded": "Hesap gerekmez",
  "common.noDataForThisPeriod": "Bu dönem için veri yok",
  "common.noLocationsFound": "Konum bulunamadı",
  "common.noNetatmoWeatherStationYet": "Henüz bir netatmo hava istasyonunuz yok.",
  "common.noOutdoorModule": "Bu istasyon için işlevsel bir dış mekan modülü yoktur.",
  "common.noSearchResults": "Aramanızla eşleşen makale yok",
  "common.noStationsFound": "İstasyon bulunamadı",
  "common.noThermostatYet": "Henüz termostatınız yok.",
  "common.notNow": "Şimdi Değil",
  "common.notPurchasedYet": "Görünüşe göre bu henüz satın alınmadı.",
  "common.notReachable": "Ulaşılamıyor",
  "common.now": "Şimdi",
  "common.noWeatherStation": "Hava istasyonu yok",
  "common.noWeatherStationYet": "Henüz bir hava istasyonunuz yok.",
  "common.numberOfActiveWarnings": "{warning_count} aktif Hava Durumu",
  "common.onThisPage": "Bu sayfada",
  "common.openSettings": "Ayarlar Aç",
  "common.orChooseMonthly": "Veya aylık seçin:",
  "common.outdoor": "Dış mekan",
  "common.outdoorTemperature": "Dış mekan sıcaklığı",
  "common.pageNotFound": "Sayfa Bulunamadı",
  "common.pageNotFoundDescription": "Aradığınız sayfa mevcut değil veya taşınmış.",
  "common.passwordUpdated": "Parola başarıyla güncellendi.",
  "common.personalWeatherIntelligence": "Kişisel Hava Durumu Zekanız",
  "common.platformMobileApp": "Mobil uygulama",
  "common.platformMobileOnly": "Yalnızca mobil uygulamada",
  "common.platformWebApp": "Web uygulaması",
  "common.platformWebOnly": "Yalnızca web uygulamasında",
  "common.popularArticles": "Popüler makaleler",
  "common.premiumAccount": "Premium hesabı",
  "common.premiumDescription": "Premium abonelik, gelişmiş hava durumu analizi, grafik karşılaştırmaları, bölgesel tahmin modelleri ve çok daha fazlası gibi birçok ek özelliğin kilidini açar.",
  "common.premiumFeatureAlerts": "Hava Uyarıları",
  "common.premiumFeatureAnalysis": "Gelişmiş Hava Analizi",
  "common.premiumFeatureCharts": "Grafik Karşılaştırmaları",
  "common.premiumFeatureExport": "Veri Dışa Aktarma",
  "common.premiumFeatureForecast": "Bölgesel Tahmin Modelleri",
  "common.premiumFeatureNotification": "Durum Çubuğu Widget'ı",
  "common.premiumFeatureTitle": "Premium Özellik",
  "common.premiumFeatureWidgets": "Ana ekran widget'ları",
  "common.pressureSummary": "Basınç özeti",
  "common.previous": "Öncesi",
  "common.previousHours": "Önceki saatler",
  "common.profileUpdated": "Profil başarıyla güncellendi.",
  "common.purchasedNetatmoPro": "Daha önce NetatMo Pro ({date}) satın almışsınızdır. Premium özelliklerin bir alt kümesine erişmenizi sağlar. Tüm premium özelliklere erişmek istiyorsanız aşağıdaki tekliflerden birine abone olun.",
  "common.radarDataAttribution": "Radar verileri: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Yağmur",
  "common.rainEvents": "Yağmur Etkinlikleri",
  "common.rainfallMeasurement": "Yağış ölçümü",
  "common.rainRadar": "Yağmur radarı",
  "common.rainRadarDescription": "Haritada yağmur radar kaplamasını göster",
  "common.rainSummary": "Yağmur Özeti",
  "common.range": "Menzil",
  "common.recentLocations": "Son",
  "common.recentLocationsEmpty": "Yakın tarihin boş.",
  "common.recentStations": "Son İstasyonlar",
  "common.relatedArticles": "İlgili Makaleler",
  "common.relay": "Röle",
  "common.removeFromFavorites": "Favorilerden kaldır",
  "common.renameSensors": "Sensörleri Yeniden Adlandır",
  "common.resetZoom": "Zoom'u sıfırla",
  "common.restorePurchase": "Satın Alma Geri Yükle",
  "common.room": "Oda",
  "common.rooms": "Odalar",
  "common.savingsPercent": "%{percent} Tasarruf",
  "common.searchArticles": "Makale ara...",
  "common.searchForALocation": "Konum ara...",
  "common.searchForLocation": "Bir konum arayın",
  "common.searchForWeatherStation": "Hava istasyonu arayın",
  "common.searchResults": "Arama Sonuçları",
  "common.searchResultsEmpty": "Sonuç bulunamadı.",
  "common.searchResultsFound": "{count, plural, one {# sonuç bulundu} other {# sonuç bulundu}}",
  "common.searchStationsDescription": "Yakındaki hava istasyonlarını bulmak için bir şehir, adres veya yer adı girin.",
  "common.searchStationsHint": "Dünyanın herhangi bir yerindeki hava istasyonlarını keşfetmek için yukarıdaki arama çubuğunu kullanın.",
  "common.selectStationForComparison": "Karşılaştırmak için bir istasyon seçin",
  "common.selectWeatherForecastProvider": "Lütfen bir hava sağlayıcısı seçin",
  "common.serialNumber": "Seri numarası",
  "common.share": "Paylaş",
  "common.shareOutdoorMeasures": "Açık hava önlemlerinizi paylaşın",
  "common.shareOutdoorMeasuresDescription": "Açık hava önlemlerinizi başkaları tarafından görülebilir hale getirerek Smartmixin topluluğuna katılın. İç mekan önlemleri asla paylaşılmayacak.",
  "common.shareYourWeather": "Havanızı Paylaşın",
  "common.signalAverage": "Orta",
  "common.signalBad": "Zayıf",
  "common.signalGood": "İyi",
  "common.signalStrength": "Sinyal gücü",
  "common.signalUnknown": "Bilinmeyen",
  "common.skip": "Atla",
  "common.smartThermostat": "Akıllı termostat",
  "common.smartValve": "Akıllı valf",
  "common.snow": "Kar",
  "common.start": "Başlangıç",
  "common.startFreeTrial": "Ücretsiz Denemeyi Başlat",
  "common.startTime": "Başlangıç Zamanı",
  "common.station": "istasyon",
  "common.stationAddedToFavorites": "Sık kullanılanlara istasyon eklendi",
  "common.stationComparison": "İstasyon karşılaştırması",
  "common.stationComparisonDescription": "Tarihsel hava durumu verilerini başka bir istasyonla karşılaştırın",
  "common.stationInformation": "İstasyon bilgileri",
  "common.stationName": "İstasyon adı",
  "common.stationObservationsDescription": "Hava istasyonlarından en son gözlemleri görüntüleyin",
  "common.stationRemovedFromFavorites": "İstasyon favorilerinden kaldırıldı",
  "common.stations": "istasyonlar",
  "common.stationsNear": "Yakındaki istasyonlar",
  "common.stationType": "İstasyon tipi",
  "common.statusOffline": "Çevrimdışı",
  "common.statusOnline": "Çevrimiçi",
  "common.statusStale": "Eski",
  "common.statusSyncing": "Senkronize ediliyor",
  "common.stillNeedHelp": "Hâlâ yardıma mı ihtiyacınız var?",
  "common.stillNeedHelpDescription": "Bu makale sorunuzu yanıtlamadıysa size doğrudan yardımcı olmaktan memnuniyet duyarım.",
  "common.subscribeNow": "Şimdi abone ol - deneme süresi yok",
  "common.sumOverThePeriod": "Dönem boyunca toplam",
  "common.switchToPremium": "Smartmixin Premium'a geç",
  "common.temperatureShort": "Sıcaklık",
  "common.temperatureSummary": "Sıcaklık Özeti",
  "common.thankYouForFeedback": "Geri bildiriminiz için teşekkürler!",
  "common.thenPrice": "sonra {price}",
  "common.timeSelection": "Zaman seçimi",
  "common.timezone": "Zaman dilimi",
  "common.totalDuration": "Toplam Süre",
  "common.tryAnotherLocation": "Bu konumun yakınında hava istasyonu bulamadık. Farklı bir bölgede aramayı deneyin.",
  "common.unknown": "Bilinmeyen",
  "common.untilChanged": "Değişene kadar",
  "common.untilTime": "{time}",
  "common.updateAvailable": "Güncelleme mevcut",
  "common.updateAvailableOpenAppStore": "App Store'u açmak için dokunun",
  "common.updateAvailableOpenGooglePlay": "Google Play'i açmak için dokunun",
  "common.updateAvailableVersion": "Güncelleme mevcut: v{version}",
  "common.upgrade": "Güncelleme",
  "common.upgradeRequiredAndroid": "Başvurunuzun yükseltilmesi gereklidir. Yükseltmek için Google Play'i ziyaret edin.",
  "common.upgradeRequiredIos": "Başvurunuzun yükseltilmesi gereklidir. Yükseltmek için App Store'u ziyaret edin.",
  "common.validate": "Doğrula",
  "common.validEmail": "Geçerli bir e -posta adresi gereklidir.",
  "common.very_low": "Çok düşük",
  "common.viewAsList": "Liste",
  "common.viewAsPeriods": "Dönemler",
  "common.visitNetatmoWebsite": "Netatmo web sitesini ziyaret edin",
  "common.wasArticleHelpful": "Bu makale yardımcı oldu mu?",
  "common.weatherCondition": "Hava durumu",
  "common.weatherflowNCRain": "NC Rain (Yakın Yağmur)",
  "common.weatherflowNCRainDescription": "NC Rain, Nearcast teknolojisi tarafından desteklenen Tempest Hava Durumu Sistemi aracılığıyla sağlanan ek bir veri kaynağıdır. NC Yağmur Verileri",
  "common.weatherForecastModels": "Hava Tahmin Modelleri",
  "common.weatherIntelligencePlatform": "Hava Durumu Zekası Platformu",
  "common.weatherMap": "Hava haritası",
  "common.weatherMapMetaDescription": "SmartMixin, dünya genelinde hava koşulları için etkileşimli hava durumu ve radar haritaları sunar.",
  "common.weatherObservations": "Hava Gözlemleri",
  "common.weatherStation": "Hava durumu istasyonu",
  "common.weatherStations": "Hava istasyonları",
  "common.welcome": "Smartmixine hoş geldiniz!",
  "common.whenBackHome": "Ne zaman eve döneceksin?",
  "common.wifiStrength": "WiFi Gücü",
  "common.wind": "Rüzgâr",
  "common.windMeasurement": "Rüzgâr ölçümü",
  "common.windSpeed": "Rüzgâr hızı",
  "common.windSummary": "Rüzgâr özeti",
  "common.yearToDate": "Sene başından beri",
  "common.yes": "Evet",
  "common.zoomImage": "Görseli büyüt",
  "forecastMaps.addColor": "Renk ekle",
  "forecastMaps.addLayer": "Katman ekle",
  "forecastMaps.autoPreview": "Otomatik",
  "forecastMaps.backToMaps": "Haritalara dön",
  "forecastMaps.browseMaps": "Haritalara göz at",
  "forecastMaps.build": "Oluştur",
  "forecastMaps.buildCompleted": "Oluşturma tamamlandı",
  "forecastMaps.builderMetaDescription": "Hava durumu modellerinin katmanlarından özel tahmin haritaları oluşturun.",
  "forecastMaps.builderTitle": "Harita oluşturucu",
  "forecastMaps.buildFailed": "Oluşturma başarısız oldu. Lütfen tekrar deneyin.",
  "forecastMaps.buildNotPossible": "Bu harita henüz oluşturulamıyor — kullanılabilir tahmin verisi yok.",
  "forecastMaps.buildProgress": "İşleniyor… {completed}/{total} adım",
  "forecastMaps.buildStarting": "Oluşturma başlatılıyor…",
  "forecastMaps.byModel": "Modele göre",
  "forecastMaps.byZone": "Bölgeye göre",
  "forecastMaps.colormap": "Renk skalası",
  "forecastMaps.colormapCustom": "Özel renkler",
  "forecastMaps.colormapGroupDomain": "Hava durumu ön ayarları",
  "forecastMaps.colormapGroupMatplotlib": "Bilimsel ön ayarlar",
  "forecastMaps.colorScale": "Renk ölçeği",
  "forecastMaps.comingSoon": "Bu görünüm çok yakında.",
  "forecastMaps.contourLevels": "Kontur seviyeleri",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Fransa",
  "forecastMaps.countryGermany": "Almanya",
  "forecastMaps.countryItaly": "İtalya",
  "forecastMaps.countryScandinavia": "İskandinavya",
  "forecastMaps.countrySpain": "İspanya",
  "forecastMaps.countrySwitzerland": "İsviçre",
  "forecastMaps.countryUnitedStates": "Amerika Birleşik Devletleri",
  "forecastMaps.customColormapMinColors": "Özel bir renk skalası en az iki renk gerektirir",
  "forecastMaps.customExtent": "Özel kapsam",
  "forecastMaps.deleteMap": "Haritayı sil",
  "forecastMaps.deleteMapBody": "“{name}” ve işlenmiş çıktıları kalıcı olarak silinecek.",
  "forecastMaps.deleteMapTitle": "Bu harita silinsin mi?",
  "forecastMaps.displayName": "Görünen ad",
  "forecastMaps.downloadMp4": "MP4 indir",
  "forecastMaps.downscaling": "Rüzgâr oku seyreltme katsayısı",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Alan çiz",
  "forecastMaps.east": "Doğu",
  "forecastMaps.editMap": "Haritayı düzenle",
  "forecastMaps.exportBuilding": "Video hazırlanıyor…",
  "forecastMaps.exportError": "Video dışa aktarılamadı. Lütfen tekrar deneyin.",
  "forecastMaps.exportMp4": "MP4 olarak dışa aktar",
  "forecastMaps.exportNotReady": "Video henüz hazır değil. Lütfen daha sonra tekrar deneyin.",
  "forecastMaps.extentDrawHint": "Alanı çizmek için harita üzerinde sürükleyin",
  "forecastMaps.extentInvalid": "Batı doğudan, güney de kuzeyden küçük olmalıdır",
  "forecastMaps.extentPanZoomHint": "Alan çerçeveyi dolduruncaya kadar kaydırın ve yakınlaştırın",
  "forecastMaps.flipbookView": "Animasyon",
  "forecastMaps.forecastModel": "Tahmin modeli",
  "forecastMaps.forkAndEdit": "Kopyala ve düzenle",
  "forecastMaps.height": "Yükseklik (inç)",
  "forecastMaps.hourOffset": "+{hour} sa",
  "forecastMaps.invalidHexColor": "Geçersiz renk — #RRGGBB kullanın",
  "forecastMaps.layers": "Katmanlar",
  "forecastMaps.layerTypeBarbs": "Rüzgâr okları",
  "forecastMaps.layerTypeContour": "Kontur çizgileri",
  "forecastMaps.layerTypeFilledContour": "Dolu konturlar",
  "forecastMaps.layerTypeMagnitude": "Büyüklük",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektör alanı",
  "forecastMaps.leave": "Ayrıl",
  "forecastMaps.levelsCount": "Adet",
  "forecastMaps.levelsInvalid": "Geçersiz kontur seviyeleri",
  "forecastMaps.levelsModeArange": "Sabit adım",
  "forecastMaps.levelsModeExplicit": "Açık değerler",
  "forecastMaps.levelsModeLinspace": "Eşit aralıklı (adet)",
  "forecastMaps.levelsStep": "Adım",
  "forecastMaps.levelsValues": "Değerler",
  "forecastMaps.levelsValuesHint": "Virgülle ayrılmış, artan",
  "forecastMaps.localTimeHint": "Yerel saatinizle gösterilir",
  "forecastMaps.map": "Harita",
  "forecastMaps.mapDescription": "Açıklama",
  "forecastMaps.mapName": "Harita adı",
  "forecastMaps.mapNameRequired": "Bir ad girin",
  "forecastMaps.mapSettings": "Harita ayarları",
  "forecastMaps.mapView": "Etkileşimli harita",
  "forecastMaps.maxLayersReached": "Bu harita en fazla {max} katman sınırına ulaştı.",
  "forecastMaps.maxValue": "Maksimum değer",
  "forecastMaps.memoryBudgetExceeded": "Çözünürlük işleme bütçesini aşıyor — DPI'ı veya yüksekliği azaltın",
  "forecastMaps.memoryBudgetUsage": "İşleme bütçesi: {percent}%",
  "forecastMaps.metaDescription": "Hava durumu modellerinin çalıştırmalarından üretilen animasyonlu tahmin haritaları.",
  "forecastMaps.metric": "Ölçüm",
  "forecastMaps.metricRequired": "Bir ölçüm seçin",
  "forecastMaps.metricUnavailable": "Bu model için kullanılamıyor",
  "forecastMaps.minBelowMax": "Minimum, maksimumdan küçük olmalıdır",
  "forecastMaps.minMaxRequired": "Bu katman türü için minimum ve maksimum değerler zorunludur",
  "forecastMaps.minValue": "Minimum değer",
  "forecastMaps.modelNoRun": "Henüz tamamlanmış bir çalıştırma yok",
  "forecastMaps.moveLayerDown": "Aşağı taşı",
  "forecastMaps.moveLayerUp": "Yukarı taşı",
  "forecastMaps.myMaps": "Haritalarım",
  "forecastMaps.nanClipToMin": "Minimuma kırp",
  "forecastMaps.nanMask": "Maskele",
  "forecastMaps.nanPolicy": "Eksik veriler",
  "forecastMaps.nanSkip": "Atla",
  "forecastMaps.newMap": "Yeni harita",
  "forecastMaps.noCompletedRun": "Bu harita henüz oluşturulmadı. Lütfen daha sonra tekrar kontrol edin.",
  "forecastMaps.noLayers": "Henüz katman yok. Başlamak için bir katman ekleyin.",
  "forecastMaps.noMapsAvailable": "Henüz kullanılabilir tahmin haritası yok.",
  "forecastMaps.north": "Kuzey",
  "forecastMaps.opacity": "Opaklık",
  "forecastMaps.overlayLegend": "Lejant",
  "forecastMaps.pause": "Duraklat",
  "forecastMaps.play": "Oynat",
  "forecastMaps.pointValueError": "Bu nokta için tahmin yüklenemedi.",
  "forecastMaps.pointValueLoading": "Tahmin yükleniyor…",
  "forecastMaps.pointValueUnavailable": "Bu saat için veri yok.",
  "forecastMaps.presets": "Ön ayarlar",
  "forecastMaps.preview": "Önizleme",
  "forecastMaps.previewEmptyHint": "Önizleme oluşturmak için en az bir geçerli katman yapılandırın.",
  "forecastMaps.previewFailed": "Önizleme başarısız oldu",
  "forecastMaps.previewHour": "Tahmin saati",
  "forecastMaps.previewRendering": "Önizleme işleniyor…",
  "forecastMaps.projection": "Projeksiyon",
  "forecastMaps.projectionLambertConformal": "Lambert konform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografik",
  "forecastMaps.regionEurope": "Avrupa",
  "forecastMaps.regionNorthAmerica": "Kuzey Amerika",
  "forecastMaps.removeColor": "Rengi kaldır",
  "forecastMaps.removeLayer": "Katmanı kaldır",
  "forecastMaps.retry": "Tekrar dene",
  "forecastMaps.run": "Çalıştırma: {run}",
  "forecastMaps.save": "Kaydet",
  "forecastMaps.selectExtentOnMap": "Haritada alan seç",
  "forecastMaps.south": "Güney",
  "forecastMaps.title": "Tahmin haritaları",
  "forecastMaps.uMetric": "U bileşeni",
  "forecastMaps.unitConversion": "Birim dönüştürme",
  "forecastMaps.unitNone": "Yok",
  "forecastMaps.unsavedChangesBody": "Kaydedilmemiş değişiklikleriniz var. Ayrılıp bunlar atılsın mı?",
  "forecastMaps.unsavedChangesTitle": "Kaydedilmemiş değişiklikler",
  "forecastMaps.useCurrentView": "Geçerli görünümü kullan",
  "forecastMaps.useModelDomain": "Kapalı: modelin tüm alanı kullanılır",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U ve V ölçümleri farklı olmalıdır",
  "forecastMaps.validTime": "Geçerlilik: {time}",
  "forecastMaps.valueBetween": "{min} ile {max} arasında olmalıdır",
  "forecastMaps.variable": "Değişken",
  "forecastMaps.viewMap": "Haritayı görüntüle",
  "forecastMaps.vMetric": "V bileşeni",
  "forecastMaps.west": "Batı",
  "forecastMaps.windAnimation": "Rüzgâr animasyonu",
  "intro.locationDescription": "Bulunduğun konuma özel doğru tahminler almak için konum erişimini etkinleştir — artık genel tahminlere son.",
  "intro.locationTitle": "Sana özel tahminler",
  "intro.notificationDescription": "Yağmur, kar veya şiddetli hava koşulları gibi önemli değişiklikleri zamanında öğrenmek için bildirimleri aç.",
  "intro.notificationsTitle": "Hava değişikliklerini kaçırmayın",
  "intro.readyDescription": "Kesin tahminler, gerçek zamanlı hava durumu içgörüleri ve dünya çapındaki istasyon verileri — hepsi güçlü bir uygulamada.",
  "intro.readyTitle": "Hazırsınız!",
  "intro.welcomeDescription": "En iyi hava durumu ajanslarının sağladığı hiper yerel tahminler ve dünya genelindeki 40.000'den fazla hava istasyonuna erişim ile geçmiş ve mevcut gerçek koşulları görün.",
  "intro.welcomeTitle": "Havanız, yeniden tasarlandı",
  "landing.alerts": "Uyarı",
  "landing.alertsDescription": "Kendi uyarılarınızı oluşturun ve tetiklendiği anda bilgilendirin.",
  "landing.featureAlertsDescription": "İlgilendiğiniz koşullar için özel uyarılar ayarlayın—sıcaklık, rüzgâr, yağış ve daha fazlası.",
  "landing.featureAlertsTitle": "Akıllı uyarılar",
  "landing.featureAnalyticsDescription": "Etkileşimli grafikler, yan yana karşılaştırmalar ve temel ölçümlerin ötesinde trend analiziyle verilerinize dalın.",
  "landing.featureAnalyticsTitle": "Güçlü analitik",
  "landing.featureExportDescription": "Excel'de analiz, diğer sistemlerle entegrasyon veya yedekleme için verilerinizi CSV formatında indirin.",
  "landing.featureExportTitle": "Her yere dışa aktar",
  "landing.featureForecastDescription": "GFS, ECMWF, ICON ve daha fazlası dahil 10'dan fazla hava modelinden tahminleri karşılaştırarak konumunuz için hangisinin en iyi çalıştığını görün.",
  "landing.featureForecastTitle": "Tahmin karşılaştırması",
  "landing.featureHistoryDescription": "Saatlik, günlük ve aylık ölçekli geçmiş verilere erişin. Araştırma veya kişisel arşivler için CSV'ye aktarın.",
  "landing.featureHistoryTitle": "Zengin geçmiş",
  "landing.featureMultiBrandDescription": "Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow ve daha fazlasından istasyonları bağlayın—hepsi tek bir panelde.",
  "landing.featureMultiBrandTitle": "Çoklu marka desteği",
  "landing.featuresSubtitle": "Temel bir hava istasyonu uygulamasından daha fazlasını isteyen hava durumu meraklıları için tasarlandı.",
  "landing.featuresTitle": "Hava durumu analizi için ihtiyacınız olan her şey",
  "landing.finalCtaButton": "Ücretsiz hesap oluşturun",
  "landing.finalCtaSubtitle": "Hava durumu verileri için SmartMixin'e güvenen binlerce hava durumu meraklısına katılın.",
  "landing.finalCtaTitle": "Hava durumu deneyiminizi geliştirmeye hazır mısınız?",
  "landing.forecastDescription": "En iyi hava tahmini modellerinden bazılarına erişin ve havanın ne olacağına dair kendi fikrinizi elde etmek için bunları karşılaştırın.",
  "landing.forecasts": "Tahminler",
  "landing.heroCta": "Ücretsiz başlayın",
  "landing.heroDescription": "Herhangi bir markadan birden fazla hava istasyonunu birleştirin, tahmin modellerini karşılaştırın ve verilerinizi ayrıntılı grafikler ve dışa aktarımlarla analiz edin.",
  "landing.heroSecondaryCta": "Özellikleri görüntüle",
  "landing.heroTagline": "Hava durumu meraklıları için",
  "landing.heroTitle": "Tüm hava durumu verileri. Tek platform.",
  "landing.pricingFeatureAdvancedMetrics": "Gelişmiş metrikler",
  "landing.pricingFeatureAlerts": "Özel uyarılar",
  "landing.pricingFeatureExport": "Veri dışa aktarma (CSV)",
  "landing.pricingFeatureForecastComparison": "Tahmin karşılaştırma",
  "landing.pricingFeatureForecasts": "Tahmin modelleri",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "Tüm modeller (10+)",
  "landing.pricingFeatureReports": "Analizler ve raporlar",
  "landing.pricingFeatureStationComparison": "İstasyon karşılaştırma",
  "landing.pricingFeatureWidgets": "Ana ekran widget'ları",
  "landing.pricingFeatureYearOverYear": "Yıldan yıla analiz",
  "landing.pricingFree": "Ücretsiz",
  "landing.pricingFreeCta": "Başlayın",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "En popüler",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Başlayın",
  "landing.pricingPremiumDescription": "Aylık 1,99 €'den başlayan fiyatlarla — web, App Store veya Google Play'den abone olun",
  "landing.pricingSubtitle": "Ücretsiz başlayın, daha fazlasına ihtiyaç duyduğunuzda yükseltin.",
  "landing.pricingTitle": "Basit, şeffaf fiyatlandırma",
  "landing.smartMixinDescription": "SmartMixin, hava istasyonunuza ve dünya çapında 40K+ diğer istasyonlara erişim sağlayan bir uygulamadır. Hava durumu verilerini görmenize ve anlamanıza yardımcı olur.",
  "landing.statBrands": "Desteklenen markalar",
  "landing.statForecasts": "Tahmin modeli",
  "landing.statStations": "Bağlı istasyon",
  "landing.supportedDevices": "Desteklenen cihazlar",
  "landing.supportedDevicesDescription": "Dünya Meteoroloji Örgütü'nden gelen istasyonların üstünde, Smartmixin artan sayıda hava istasyonu markasını desteklemektedir.",
  "landing.supportedDevicesNote": "Ayrıca Dünya Meteoroloji Örgütü'nden 40.000'den fazla kamu istasyonu",
  "landing.supportedDevicesSubtitle": "Önde gelen markalardan hava istasyonlarını bağlayın ve tüm verileri tek bir yerde görün.",
  "landing.supportedDevicesTitle": "İstasyonlarınızla çalışır",
  "landing.thermostatDescription": "Isıtma kalıplarını dış koşullarla karşılaştırmak için Netatmo termostatınızı bağlayın.",
  "landing.thermostatManufacturers": "Termostat üreticileri, ısıtmayı dış mekan koşullarıyla ilişkilendirmek için de desteklenmektedir.",
  "landing.thermostatTitle": "Akıllı ev entegrasyonu",
  "landing.weatherAnalysis": "Hava analizi",
  "landing.weatherAnalysisDescription": "SmartMix, hava durumu verilerini analiz etmenizi sağlayan birçok veri görselleştirme ile birlikte gelir.",
  "landing.weatherAssistant": "Hava Durumu Asistanınız",
  "landing.weatherAssistantDescription": "Mevcut, tarihsel veya tahmin hava koşullarıyla ilgileniyor olun, Smartmixin, ihtiyaç duyduğunuzda çok sayıda bilgi sağlar.",
  "landing.weatherForecastModels": "Hava Tahmin Modelleri",
  "landing.weatherForecastModelsDescription": "Smartmixin, en doğru hava durumu tahmin modellerine erişim sağlar. Tahminlerini kolayca karşılaştırabilir ve kendi fikrinizi yapabilirsiniz.",
  "landing.weatherMap": "Hava durumu haritası",
  "landing.weatherMapDescription": "Haritaya göz atın ve dünyanın herhangi bir yerinde havanın ne olduğunu görselleştirin.",
  "network.cancelError": "İstek iptal edildi",
  "network.connectionError": "Sunucu mevcut değil",
  "network.networkError": "Ağ mevcut değil",
  "network.serverError": "Bir şeyler ters gitti ...",
  "network.timeoutError": "Bağlantı Zaman Aşımı",
  "network.unknownError": "Bilinmeyen hata",
  "providerHints.ambientWeatherApiKey": "ambientweather.net hesap ayarlarınızda oluşturulur.",
  "providerHints.davisApiSecret": "Yalnızca V2 API anahtarını oluşturduğunuzda bir kez gösterilir — güvenli bir yerde saklayın.",
  "providerHints.davisV2ApiKey": "weatherlink.com üzerindeki V2 API anahtarları sayfasından.",
  "providerHints.ecowittApi": "Ecowitt hesabınızın API sayfasından.",
  "providerHints.ecowittApp": "Uygulama anahtarı, yine Ecowitt hesabınızdan.",
  "providerHints.myAcuriteCredentialsBanner": "My AcuRite hesabınızın e-posta ve şifresini kullanın — SmartMixin girişini değil.",
  "providerHints.myAcuriteEmail": "My AcuRite hesabınızın e-postası — SmartMixin girişiniz değil.",
  "providerHints.myAcuritePassword": "My AcuRite hesabınızın şifresi.",
  "providerHints.weatherflowToken": "tempestwx.com → ayarlar → veri yetkilerinden kişisel kullanım belirteci.",
  "providerHints.wundergroundEditKey": "Başka bir anahtar kullan",
  "providerHints.wundergroundKey": "Weather Underground hesabınızın API anahtarları sayfasından alınan uzun bir dizi — wunderground.com şifreniz değil.",
  "providerHints.wundergroundKeyExample": "örn. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API anahtarı doğrulandı",
  "providerHints.wundergroundKeyVerifying": "Anahtar doğrulanıyor…",
  "providerHints.wundergroundNoStationsNearby": "Bu konumun yakınında istasyon bulunamadı. Doğrudan bir istasyon kimliği girmeyi deneyin.",
  "providerHints.wundergroundStationId": "Herhangi bir Weather Underground istasyon kimliği — sizinki veya yakınınızdaki bir kamuya açık istasyon.",
  "providerHints.wundergroundStationIdExample": "örn. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Ambient Weather API anahtarınızı alın.",
  "providerIntro.davisStep2": "Davis V2 API anahtarınızı ve API gizli anahtarınızı alın.",
  "providerIntro.ecowittStep2": "Ecowitt API anahtarı ve Uygulama anahtarınızı alın.",
  "providerIntro.getStarted": "Başla",
  "providerIntro.myAcuriteStep2": "Mevcut My AcuRite hesabınızın e-posta ve şifresini kullanın.",
  "providerIntro.netatmoEnergyStep2": "İstendiğinde Netatmo'ya giriş yapın — API anahtarı gerekmez.",
  "providerIntro.netatmoWeatherStep2": "İstendiğinde Netatmo'ya giriş yapın — API anahtarı gerekmez.",
  "providerIntro.signupBanner": "Neredeyse tamam — {provider} bağlantısı kurmak için ücretsiz SmartMixin hesabınızı oluşturun.",
  "providerIntro.step1": "SmartMixin hesabınızda oturum açın ({provider} girişinizde DEĞİL).",
  "providerIntro.step3EmailPassword": "Buraya girin.",
  "providerIntro.step3KeyOrToken": "Buraya yapıştırın.",
  "providerIntro.step3OAuth": "Açılan pencerede SmartMixin'i yetkilendirin.",
  "providerIntro.step3Wunderground": "API anahtarınızı yapıştırın, ardından yakındaki bir istasyonu seçin veya herhangi bir istasyon kimliği girin.",
  "providerIntro.title": "{provider} bağlantısı",
  "providerIntro.weatherflowStep2": "Kişisel kullanım Tempest belirtecinizi alın.",
  "providerIntro.wundergroundBrowsePublic": "İstasyonunuz yok mu? Kamuya açık olanlara göz atın",
  "providerIntro.wundergroundFindNearby": "Yakınımdaki istasyonları bul",
  "providerIntro.wundergroundOrEnterId": "Veya bir istasyon kimliği girin",
  "providerIntro.wundergroundStep2": "Weather Underground API anahtarınızı alın. Daha sonra herhangi bir istasyona bağlanabilirsiniz — kendinize ait veya kamuya açık.",
  "reports.agroMeteorology": "Agrometeoroloji",
  "reports.analysis": "Analiz",
  "reports.annualCumulativeRainfallComparison": "Yıllık Kümülatif Yağış Karşılaştırması",
  "reports.annualHeatingDurationComparison": "Yıllık ısıtma süresi karşılaştırması",
  "reports.annualHeatingEfficiency": "Yıllık Isıtma Verimliliği",
  "reports.annualIndoorComparison": "Yıllık İç Mekan Karşılaştırması",
  "reports.annualIndoorReport": "Yıllık İç Mekan Raporu",
  "reports.annualOutdoorComparison": "Yıllık dış mekan karşılaştırması",
  "reports.annualOutdoorReport": "Yıllık Açık Hava Raporu",
  "reports.annualReport": "Yıllık Rapor",
  "reports.annualSolarReport": "Yıllık Güneş Raporu",
  "reports.annualWaterBalance": "Yıllık Su Dengesi",
  "reports.annualWaterBalanceCarryOver": "Önceki yıldan devret",
  "reports.annualWaterBalanceDescription": "Su dengesi (basitleştirilmiş versiyon, sadece yağmur ve buharlaştırma hızı kullanılır) su kaynağını yönetmeye yardımcı olur",
  "reports.avgHumidity": "Ortalama nem",
  "reports.avgMaxTemperature": "Ortalama t ° maks.",
  "reports.avgMetric": "Ortalama {metric}",
  "reports.avgMinTemperature": "Ortalama t ° dk",
  "reports.avgPressure": "Ortalama basınç",
  "reports.avgTemperature": "Ortalama sıcaklık",
  "reports.climateNormalPeriodOfRecord": "Ölçüm dönemi ({years} yıl)",
  "reports.climateNormals": "İklim normalleri",
  "reports.climateNormalStandardLabel": "Standart normal ({period})",
  "reports.climateTrendPerDecade": "Sıcaklık eğilimi: on yılda {value} ({years} yıllık dönem)",
  "reports.coldestMonthRanking": "Kayıtlardaki en soğuk {month}",
  "reports.comfortable": "Rahat (% 45 {lessThan} nem ≤% 60)",
  "reports.cumulativeRainfall": "Kümülatif yağış",
  "reports.cumulativeRainfallDescription": "Seçilen dönem boyunca biriken toplam yağışı takip edin.",
  "reports.dailyMaxRainfall": "Günlük Max. yağış",
  "reports.dataExport": "Dışa aktarma verileri",
  "reports.dataExportXlsxFormatDescription": "İstasyonunuzun tüm verilerini Excel formatında (*.xlsx) dışa aktarın. Düğmeye tıkladıktan sonra, birkaç dakika sonra işlenmiş verilerle bir e -posta alırsınız.",
  "reports.daysOfData": "{days} günlük veri",
  "reports.daysWithFrost": "Donlu günler",
  "reports.daysWithHeavyRain": "Şiddetli yağmurlu günler (≥ {threshold})",
  "reports.daysWithoutThaw": "Çözülmeden günler",
  "reports.daysWithStrongFrost": "Güçlü donlu günler",
  "reports.emailSent": "Posta kutunuza bir e -posta gönderildi",
  "reports.frostDays": "Don günü sayısı",
  "reports.grasslandTemperatureSum": "Otlak sıcaklığı toplamı",
  "reports.grasslandTemperatureSumDescription": "İlkbaharda {threshold} toplamı aşılırsa, bitki örtüsünün sürdürülebilir başlangıcına ulaşıldı (Avrupa'da çalışır)",
  "reports.growingDegreeDays": "Büyüme derece günleri",
  "reports.highPressure": "Antisiklon (ortalama basınç ≥ 1013Mbar)",
  "reports.iceDays": "Buzlu günler",
  "reports.indoorReport": "İç mekan raporu",
  "reports.keyFacts": "Anahtar Gerçekler",
  "reports.longestDrySpell": "En uzun kurak dönem",
  "reports.longestRunOfRainyDays": "Yağmurlu günlerin en uzun koşusu",
  "reports.longestRunWithoutRun": "Yağmur olmadan en uzun koşu",
  "reports.longestWetSpell": "En uzun yağışlı dönem",
  "reports.lowPressure": "Düşük basınç (ortalama basınç {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Maksimum nem",
  "reports.maxMetric": "Maksimum {metric}",
  "reports.maxPressure": "Maksimum basınç",
  "reports.maxPressureMagnitude24h": "Maksimum büyüklük (/24 saat)",
  "reports.maxTemperature": "Maksimum sıcaklık",
  "reports.maxTempGreaterThan": "T ° maks.",
  "reports.maxTempMagnitude24h": "Maksimum büyüklük (/24 saat)",
  "reports.minHumidity": "Minimum nem",
  "reports.minMetric": "Minimum {metric}",
  "reports.minPressure": "Minimum basınç",
  "reports.minPressureMagnitude24h": "Minimum büyüklük (/24 saat)",
  "reports.minTemperature": "Minimum sıcaklık",
  "reports.minTempMagnitude24h": "Minimum büyüklük (/24 saat)",
  "reports.monthlyAverageCountdown": "Bu ay {days} gün daha",
  "reports.monthlyAverageCountdownDetail": "O zaman bu ayın ortalaması ve sıralaması görünür.",
  "reports.monthlyAverageRule": "Aylık ortalamalar ve sıralamalar, bir takvim ayında {days} gün kaydedildiğinde görünür.",
  "reports.monthlyHeatingEfficiency": "Aylık ısıtma verimliliği",
  "reports.monthlyIndoorReport": "Aylık İç Mekan Raporu",
  "reports.monthlyOutdoorReport": "Aylık dış mekan raporu",
  "reports.monthlyReport": "Aylık Rapor",
  "reports.monthlySolarReport": "Aylık Güneş Raporu",
  "reports.monthlyWindReport": "Aylık Rüzgâr Raporu",
  "reports.monthsOfData": "{months} aylık veri",
  "reports.numberOfDays": "Gün sayısı",
  "reports.onThisDayInHistory": "Tarihte bugün",
  "reports.outdoorReport": "Açık hava raporu",
  "reports.overviewSection": "Genel bakış",
  "reports.rainfall": "Yağış",
  "reports.rainyDays": "Yağmurlu Günler",
  "reports.recordDailyRain": "En yağışlı gün",
  "reports.recordHigh": "Sıcak rekoru",
  "reports.recordLow": "Soğuk rekoru",
  "reports.recordsAndClimatology": "Rekorlar ve iklim",
  "reports.recordsSince": "{date} tarihinden beri rekorlar",
  "reports.recordWindGust": "En güçlü rüzgâr hamlesi",
  "reports.relativelyWet": "Nispeten ıslak (% 60 {lessThan} nem ≤% 80)",
  "reports.sectionReportCount": "{count} rapor",
  "reports.sendEmail": "E -posta Gönder",
  "reports.summerDays": "Yaz günleri",
  "reports.tooDry": "Çok kuru (nem ≤%45)",
  "reports.tooWet": "Çok ıslak (nem {greaterThan}%80)",
  "reports.tropicalNights": "Tropik Geceler",
  "reports.unlockPremiumSubtitle": "SmartMixin Premium’a dahildir",
  "reports.unlockPremiumTitle": "{count} premium özelliğin kilidini aç",
  "reports.warmestMonthRanking": "Kayıtlardaki en sıcak {month}",
  "reports.waterBalance": "Su dengesi",
  "reports.yearsOfData": "{years} yıllık veri",
  "reports.yearToDateTemperatureComparison": "Yıl başından bugüne sıcaklık karşılaştırması",
  "sensors.aqiByChannel": "Kanala göre AQI",
  "sensors.bgtSensors": "Siyah küre ve WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "AQI karşılaştır",
  "sensors.compareHumidity": "Nemi karşılaştır",
  "sensors.compareMoisture": "Toprak nemini karşılaştır",
  "sensors.comparePm25": "PM2.5 karşılaştır",
  "sensors.compareTemperatures": "Sıcaklıkları karşılaştır",
  "sensors.depthByChannel": "Kanala göre derinlik",
  "sensors.heatStressExtreme": "Aşırı ısı stresi",
  "sensors.heatStressModerate": "Orta düzey ısı stresi",
  "sensors.heatStressNone": "Isı stresi yok",
  "sensors.heatStressStrong": "Güçlü ısı stresi",
  "sensors.heatStressVeryStrong": "Çok güçlü ısı stresi",
  "sensors.humidityByChannel": "Kanala göre nem",
  "sensors.indoorAirQualityPm": "PM2.5 ve PM10 AQI",
  "sensors.indoorClimate": "İç ortam iklimi",
  "sensors.indoorCo2Levels": "CO2 seviyeleri",
  "sensors.indoorTemperatureAndHumidity": "Sıcaklık ve nem",
  "sensors.last24Hours": "24 saat",
  "sensors.last30Days": "30 gün",
  "sensors.last7Days": "7 gün",
  "sensors.leafTemperatureByChannel": "Kanala göre yaprak sıcaklığı",
  "sensors.leafWetnessByChannel": "Kanala göre yaprak nemi",
  "sensors.lightningSensor": "Yıldırım",
  "sensors.moistureByChannel": "Kanala göre toprak nemi",
  "sensors.noDataAvailable": "Veri mevcut değil",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "Kanala göre PM2.5",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Kanal seçin",
  "sensors.sensorDetailDescription": "Sensör kanallarınızın geçmiş verilerini ve eğilimlerini görüntüleyin.",
  "sensors.sensorHistory": "Sensör geçmişi",
  "sensors.soilConductivityByChannel": "Kanala göre iletkenlik",
  "sensors.soilTemperatureByChannel": "Kanala göre toprak sıcaklığı",
  "sensors.strikesToday": "Bugün düşen yıldırım",
  "sensors.temperatureByChannel": "Kanala göre sıcaklık",
  "sensors.viewChart": "Grafiği görüntüle",
  "settings.about": "Hakkında",
  "settings.aboutDescription": "Lisans Sözleşmesi, Gizlilik Politikası",
  "settings.account": "Hesap",
  "settings.accountDescription": "Profil, şifre değişikliği",
  "settings.accountIntro": "Veriler hesabınızla ilgilidir:",
  "settings.accountOnHoldTitle": "Hesap beklemede",
  "settings.accountSection": "Hesap",
  "settings.addForecastModel": "Model ekle",
  "settings.appearance": "Görünüm",
  "settings.appearanceDescription": "Tema ve görüntüleme seçenekleri",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arapça",
  "settings.atYourStations": "İstasyonlarınızda mevcut",
  "settings.availableServices": "Mevcut",
  "settings.bulgarian": "Bulgarca",
  "settings.cannotDisconnectLastAccount": "Tek giriş yönteminizin bağlantısı kesilemez. Lütfen önce başka bir giriş yöntemi ekleyin.",
  "settings.catalan": "Katalanca",
  "settings.changeEmail": "E-postayı değiştir",
  "settings.changePassword": "Şifre değiştir",
  "settings.chartGestures": "Grafiklerde jestler",
  "settings.chartGesturesDescription": "Grafiklerde kaydırma zaman periyodunu değiştirir, Grafikler Sıkıştırma Değiştirme Zaman Ölçeği",
  "settings.choiceCount": "{count, plural, one {# kullanılabilir} other {# kullanılabilir}}",
  "settings.connect": "Bağla",
  "settings.connected": "Bağlı",
  "settings.connectedAccounts": "Bağlı hesaplar",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Bağlı",
  "settings.connectedSince": "{date} tarihinden beri bağlı",
  "settings.connectionSection": "Bağlantı",
  "settings.connectionSuccess": "{provider} hesabı başarıyla bağlandı",
  "settings.contactUs": "Bize ulaşın",
  "settings.contactUsDescription": "Yardım alın veya geri bildirim gönderin",
  "settings.coverageLoading": "Her modelin hangi istasyonlarınızı kapsadığı hesaplanıyor…",
  "settings.croatian": "Hırvatça",
  "settings.currentPassword": "Mevcut şifre",
  "settings.czech": "Çekçe",
  "settings.dailyDetailByPeriods": "Dönemlere göre günlük ayrıntı",
  "settings.dailyDetailByPeriodsDescription": "24 saati gece, sabah, öğleden sonra ve akşam olarak gruplar — günlük özetin kullandığı bölümlemenin aynısı.",
  "settings.dangerZone": "Riskli bölge",
  "settings.danish": "Danca",
  "settings.dark": "Karanlık tema",
  "settings.dataDisplay": "Veri görüntüleme",
  "settings.dateAndTime": "Tarih ve saat",
  "settings.disconnect": "Bağlantıyı kes",
  "settings.disconnectConfirmation": "{provider} hesabınızın bağlantısını kesmek istediğinizden emin misiniz?",
  "settings.disconnectionSuccess": "{provider} hesabının bağlantısı başarıyla kesildi",
  "settings.disconnectProviderDescription": "Eşitlemeyi durdurur. Geçmişiniz korunur.",
  "settings.donateButton": "Bağış yapın",
  "settings.donateDescription": "SmartMixin küçük bir ekip tarafından geliştiriliyor. Faydalı buluyorsanız, dilediğiniz tutarda tek seferlik bir bağışla gelişimine destek olabilirsiniz. Bu bir hediyedir — planınızı değiştirmez ve herhangi bir özelliği açmaz.",
  "settings.donateSuccessBody": "Bağışınız, SmartMixin'in çalışmaya ve gelişmeye devam etmesine yardımcı olur. İçtenlikle minnettarız.",
  "settings.donateSuccessTitle": "Desteğiniz için teşekkürler!",
  "settings.donateTitle": "SmartMixin'e destek olun",
  "settings.dragToReorder": "Yeniden sıralamak için sürükleyin",
  "settings.dutch": "Flemenkçe",
  "settings.emailChange": "E-posta adresini değiştir",
  "settings.emailChangeConfirmation": "E-posta değişikliği onayı",
  "settings.emailChangeFailure": "E-posta değişiklik bağlantısı geçersiz veya süresi dolmuş.",
  "settings.emailChangeSuccess": "E-postanız başarıyla {newEmail} olarak değiştirildi.",
  "settings.emailChangeVerificationSent": "Yeni e-posta adresinize bir doğrulama e-postası gönderildi. Lütfen gelen kutunuzu kontrol edin ve değişikliği onaylamak için bağlantıya tıklayın.",
  "settings.english": "İngilizce",
  "settings.everywhereElse": "Diğer her yerde",
  "settings.everywhereElseFoot": "Tercih ettiğiniz modellerin ulaşmadığı her istasyonda kullanılır.",
  "settings.everywhereElsePick": "Birini seçin",
  "settings.fallbackBlend": "SmartMixin karışımı",
  "settings.fallbackBlendSub": "Birden fazla modeli, her birini en güçlü olduğu yerde birleştirir.",
  "settings.fallbackEcmwf": "ECMWF",
  "settings.fallbackEcmwfSub": "Ulaştığı her yerde ECMWF HRES.",
  "settings.fallbackGfs": "GFS",
  "settings.fallbackGfsSub": "NOAA'nın küresel modeli. Bugün her hesabın kullandığı model.",
  "settings.fallbackResolution": "En yüksek çözünürlük",
  "settings.fallbackResolutionSub": "Her istasyonda mevcut olan en ince ağ.",
  "settings.forecastModels": "Tahmin modelleri",
  "settings.freeBannerBody": "Ücretsiz hesaplara her yerde GFS sunulur — tercih edilen modeller ve “diğer her yerde” abone olduğunuz anda çalışmaya başlar.",
  "settings.freeBannerTitle": "Tercihler Premium ile geçerlidir",
  "settings.french": "Fransızca",
  "settings.german": "Almanca",
  "settings.gestures": "Jestler",
  "settings.greek": "Yunanca",
  "settings.helpCenter": "Yardım Merkezi",
  "settings.helpCenterDescription": "SSS ve kılavuzlar",
  "settings.hungarian": "Macarca",
  "settings.integrationsSection": "Entegrasyonlar",
  "settings.italian": "İtalyanca",
  "settings.japanese": "Japonca",
  "settings.korean": "Korece",
  "settings.language": "Dil",
  "settings.languageDescription": "Tercih edilen dil",
  "settings.light": "Işık Teması",
  "settings.measurementUnits": "Ölçü birimleri",
  "settings.netatmoDashboard": "Netatmo panosu",
  "settings.netatmoLayoutCards": "Kart listesi",
  "settings.netatmoLayoutCardsDescription": "Her modül için bir kart, tek kaydırmada",
  "settings.netatmoLayoutClassic": "Klasik",
  "settings.netatmoLayoutClassicDescription": "İki kart, modüller arasında geçiş",
  "settings.netatmoNewLayoutNotice": "Yeni pano düzeni: her modül için bir kart.",
  "settings.netatmoSwitchBackToClassic": "Klasiğe dön",
  "settings.netatmoSwitchToLayout": "{layout} görünümüne geç",
  "settings.newEmailAddress": "Yeni e-posta adresi",
  "settings.newPassword": "Yeni Şifre",
  "settings.newPasswordAgain": "Yine yeni şifre",
  "settings.norwegian": "Norveççe",
  "settings.notConnected": "Bağlı değil",
  "settings.notificationsSection": "Bildirimler",
  "settings.oldPassword": "Eski Şifre",
  "settings.ongoingNotificationEnabled": "Kalıcı bildirimi etkinleştir",
  "settings.ongoingNotificationMetrics": "Gösterilen ölçümler",
  "settings.ongoingNotificationPermissionRequired": "Bildirim izni gerekli",
  "settings.ongoingNotificationPreviewHint": "Önizleme — göstermek için widget'ı açın",
  "settings.ongoingNotificationStation": "Meteoroloji istasyonu",
  "settings.ongoingNotificationStatusBar": "Durum çubuğu",
  "settings.passwordChange": "Şifre Değişikliği",
  "settings.passwordChangeDescription": "Hesabınızı güvende tutun",
  "settings.pickerShowAll": "Tüm kataloğu göster",
  "settings.pickerUnreachable": "{count, plural, one {# model daha} other {# model daha}} istasyonlarınızın hiçbirine ulaşmıyor",
  "settings.pinInUse": "Kullanımda",
  "settings.pinShadowed": "Hiç kullanılmıyor — yukarıdaki bir model tüm istasyonlarınızı kapsıyor",
  "settings.pinSlots": "{max} yuvadan {used} tanesi · seçmek için dokunun",
  "settings.pinSlotsFull": "{max} yuvanın tamamı dolu. Başka bir tane eklemek için birini kaldırın.",
  "settings.pinsUncoveredCount": "{count, plural, other {# istasyonunuzdan}} {used} tanesi: hiçbir tercih edilen model onlara ulaşmıyor — “diğer her yerde” karar verir.",
  "settings.pinsUncoveredNamed": "{stations}: hiçbir tercih edilen model {count, plural, one {ona} other {onlara}} ulaşmıyor — “diğer her yerde” karar verir.",
  "settings.pinUnreachable": "Hiç kullanılmıyor — istasyonlarınızın hiçbirine ulaşmıyor",
  "settings.pinUsedAt": "Şurada kullanılıyor: {stations}",
  "settings.pinUsedAtAll": "{count, plural, one {İstasyonunuzda kullanılıyor} other {# istasyonun tamamında kullanılıyor}}",
  "settings.pinUsedAtSome": "{count, plural, other {# istasyondan}} {used} tanesinde kullanılıyor",
  "settings.polish": "Lehçe",
  "settings.portuguese": "Portekizce",
  "settings.preferencesSection": "Tercihler",
  "settings.preferredModels": "Tercih edilen modeller",
  "settings.preferredModelsAll": "Tek liste, tüm istasyonlar",
  "settings.preferredModelsOne": "Tek liste, her yerde geçerli",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktif",
  "settings.premiumAnnualThenPrice": "Ardından 9,99 €/yıl",
  "settings.premiumAnnualTrialInfo": "{days} günlük ücretsiz deneme ile başlayın",
  "settings.premiumCurrentPlan": "Mevcut Plan",
  "settings.premiumDescription": "Premium özelliklerin kilidini aç",
  "settings.premiumDownloadApp": "Abone olmak için uygulamayı indirin:",
  "settings.premiumExpiresOn": "{date} tarihinde yenilenir",
  "settings.premiumFreePlan": "Ücretsiz",
  "settings.premiumInactive": "Abone değil",
  "settings.premiumManageWebSubscription": "Aboneliğinizi yönetin, ödeme yöntemini güncelleyin veya iptal edin.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Yıllık — 9,99 €/yıl",
  "settings.premiumSubscribedOn": "{platform} üzerinden abone olundu",
  "settings.premiumSubscribeMonthly": "Aylık — 1,99 €/ay",
  "settings.premiumSubscribeOnWeb": "Tüm premium özelliklerin kilidini açmak için şimdi abone olun.",
  "settings.premiumSubscriptionSuccess": "Aboneliğiniz etkinleştirildi! Tüm premium özelliklerin keyfini çıkarın.",
  "settings.premiumSubscriptionSuccessTitle": "Premium'a hoş geldiniz!",
  "settings.premiumWebappNotice": "Abonelikler yalnızca iOS veya Android'deki SmartMixin mobil uygulaması üzerinden satın alınabilir.",
  "settings.privacyPolicy": "Gizlilik Politikası",
  "settings.profile": "Profil",
  "settings.removePreferredModel": "{model} tercih ettiğiniz modellerden kaldır",
  "settings.resetForecastPreference": "Sıfırla",
  "settings.resetForecastPreferenceHint": "Tercih ettiğiniz modelleri siler ve SmartMixin varsayılanına döner.",
  "settings.russian": "Rusça",
  "settings.seePremium": "Premium'u gör",
  "settings.serbian": "Sırpça",
  "settings.servedNowMany": "Şu anda: {count, plural, one {istasyonunuzda} other {# istasyonun tamamında}} GFS.",
  "settings.servedNowNone": "Şu anda: her yerde GFS.",
  "settings.settings": "Ayarlar",
  "settings.signedInAs": "Şu hesapla oturum açıldı",
  "settings.slovak": "Slovakça",
  "settings.smallDecimals": "Küçük ondalıklar",
  "settings.smallDecimalsDescription": "Ondalık basamakları daha küçük boyutta göster",
  "settings.socialConnectionsIntro": "Hızlı giriş için sosyal hesaplarınızı bağlayın. Hesapları istediğiniz zaman bağlayabilir veya bağlantısını kesebilirsiniz.",
  "settings.spanish": "İspanyolca",
  "settings.statusBarWidget": "Durum çubuğu widget'ı",
  "settings.statusBarWidgetDescription": "Her zaman görünür hava verileri",
  "settings.subscriptionSection": "Abonelik",
  "settings.supportSection": "Destek",
  "settings.swedish": "İsveççe",
  "settings.systemTheme": "Sistem teması",
  "settings.termsOfService": "Hizmet Şartları",
  "settings.turkish": "Türkçe",
  "settings.ukrainian": "Ukraynaca",
  "settings.units": "Birimler",
  "settings.unitsDescription": "Uygulamada görüntülenen ölçüm birimleri",
  "settings.update": "Güncelleme",
  "settings.updateYourProfile": "Profilinizi güncelleyin",
  "settings.updateYourProfileDescription": "Ad ve görüntüleme tercihleri",
  "settings.weatherServices": "Hava durumu servisleri",
  "settings.weatherServicesConnected": "{count, plural, =0 {Bağlı hizmet yok} one {# hizmet bağlı} other {# hizmet bağlı}}",
  "settings.weatherServicesDescription": "Netatmo, Davis, Weatherflow ve diğerlerini bağlayın",
  "settings.windDirectionConvention": "Rüzgâr yönü oku",
  "settings.windDirectionConventionDescription": "Rüzgâr yönü oklarının nasıl görüntüleneceğini seçin",
  "settings.windDirectionMeteorological": "Kaynak yönü",
  "settings.windDirectionMeteorologicalDescription": "Ok, rüzgârın nereden geldiğini gösterir (meteorolojik uzlaşım)",
  "settings.windDirectionOceanographic": "Akış yönü",
  "settings.windDirectionOceanographicDescription": "Ok, rüzgârın nereye estiğini gösterir (oşinografik uzlaşım)",
  "units.absolutePressure": "Mutlak basınç",
  "units.airDensity": "Hava yoğunluğu",
  "units.airGap": "Hava boşluğu",
  "units.apparentTemperature": "Hissedilen sıcaklık",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "AVG.",
  "units.avg_wind": "Ortalama rüzgâr",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Siyah küre sıcaklığı",
  "units.boilerOn": "Kazan",
  "units.co2": "CO2",
  "units.conductivity": "İletkenlik",
  "units.coolingDegreeDays": "Soğutma Derecesi Günleri",
  "units.dailyHeatingDuration": "Günlük ısıtma süresi",
  "units.dailyPrecipitation": "Günlük yağış",
  "units.dailyRain": "Günlük yağış",
  "units.degreeDay": "Derece Günü",
  "units.degreeDayShort": "DD",
  "units.depth": "Derinlik",
  "units.depthSensors": "Derinlik sensörleri",
  "units.dewPoint": "Çiy noktası",
  "units.distance": "Mesafe",
  "units.downTrend": "aşağı",
  "units.E": "D",
  "units.E_long": "Doğu",
  "units.ENE": "DKD",
  "units.ENE_long": "Doğu-kuzeydoğu",
  "units.ESE": "DGD",
  "units.ESE_long": "Doğu-güneydoğu",
  "units.ET": "Evapotranspirasyon",
  "units.ETshort": "ET",
  "units.feelLike": "Hissettiren",
  "units.feelsLike": "Hissettiren",
  "units.footMile": "Ayak, mil",
  "units.frostPoint": "Donma noktası",
  "units.gust": "Rüzgâr hamlesi",
  "units.heatIndex": "Isı indeksi",
  "units.heatingDegreeDays": "Isıtma Derece Günleri",
  "units.heatingPower": "Isıtma gücü",
  "units.humidex": "Humidex",
  "units.humidity": "Nem",
  "units.inch": "İnç",
  "units.inchOfMercury": "İnç cıva",
  "units.kilometerPerHour": "Saatte kilometre",
  "units.knot": "Düğüm",
  "units.last12Hours": "Son 12 saat",
  "units.last24Hours": "Son 24 saat",
  "units.last3Hours": "Son 3 saat",
  "units.last6Hours": "Son 6 saat",
  "units.lastHour": "Son saat",
  "units.lastLightningImpact": "Son etki",
  "units.lastMeasure": "Son önlem",
  "units.leafSensors": "Yaprak sensörleri",
  "units.leafWetness": "Yaprak ıslaklık",
  "units.lightningDistance": "Mesafe",
  "units.lightningStrikeCount": "Yıldırım çarpması sayısı",
  "units.lightningStrikeDistance": "Yıldırım çarpması mesafesi",
  "units.max": "Maks.",
  "units.max_gust": "Maks. rüzgâr hamlesi",
  "units.maxToday": "Bugün maks.",
  "units.meterKilometer": "Metre, kilometre",
  "units.meterPerSecond": "Saniyede metre",
  "units.milePerHour": "Saatte mil",
  "units.millibar": "Milibar",
  "units.millimeter": "Milimetre",
  "units.millimeterOfMercury": "Milimetre cıva",
  "units.min": "Min.",
  "units.N": "K",
  "units.N_long": "Kuzey",
  "units.NE": "KD",
  "units.NE_long": "Kuzeydoğu",
  "units.NNE": "KKD",
  "units.NNE_long": "Kuzey-kuzeydoğu",
  "units.NNW": "KKB",
  "units.NNW_long": "Kuzey-kuzeybatı",
  "units.noise": "Gürültü",
  "units.normalizedHeatingCoefficient": "Normalleştirilmiş ısıtma katsayısı",
  "units.NW": "KB",
  "units.NW_long": "Kuzeybatı",
  "units.O3": "Ozon",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Yağış",
  "units.pressure": "Basınç",
  "units.rain": "Yağmur",
  "units.rainRate": "Yağış yoğunluğu",
  "units.referenceTemperature": "Referans sıcaklığı",
  "units.relativePressure": "Göreceli basınç",
  "units.S": "G",
  "units.S_long": "Güney",
  "units.SE": "GD",
  "units.SE_long": "Güneydoğu",
  "units.setPoint": "Ayar noktası",
  "units.snow": "Kar",
  "units.snowfall": "Kar yağışı",
  "units.soilMoisture": "Nem",
  "units.soilSensors": "Toprak sensörleri",
  "units.solarEnergy": "Güneş enerjisi",
  "units.solarRadiation": "Güneş radyasyonu",
  "units.speed": "Hız",
  "units.SSE": "GGD",
  "units.SSE_long": "Güney-güneydoğu",
  "units.SSW": "GGB",
  "units.SSW_long": "Güney-güneybatı",
  "units.stableTrend": "stabil",
  "units.sum": "Toplam",
  "units.SW": "GB",
  "units.SW_long": "Güneybatı",
  "units.temperature": "Sıcaklık",
  "units.temperatureAndHumiditySensors": "Sıcaklık ve Nem Sensörleri",
  "units.temperatureSensors": "Sıcaklık ve Nem Sensörleri",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Bugün",
  "units.upTrend": "yukarı",
  "units.uv": "UV",
  "units.visibility": "Görünürlük",
  "units.W": "B",
  "units.W_long": "Batı",
  "units.wetBulbGlobeTemperature": "Islak küre sıcaklığı",
  "units.wetBulbTemperature": "Yaş termometre sıcaklığı",
  "units.wind": "Rüzgâr",
  "units.windChill": "Rüzgâr Soğutma",
  "units.windDirection": "Rüzgâr yönü",
  "units.windRun": "Rüzgâr Koşusu",
  "units.windRunDescription": "Rüzgâr koşusu, seyahat edilen rüzgârın bir süre boyunca toplam mesafesidir",
  "units.WNW": "BKB",
  "units.WNW_long": "Batı-Kuzeybatı",
  "units.WSW": "BGB",
  "units.WSW_long": "Batı-güneybatı",
  "weatherConditions.blizzard": "Kar fırtınası",
  "weatherConditions.blowingDust": "Savrulan toz",
  "weatherConditions.blowingSnow": "Savrulan kar",
  "weatherConditions.breezy": "Hafif rüzgâr",
  "weatherConditions.clear": "Açık",
  "weatherConditions.cloudy": "Bulutlu",
  "weatherConditions.drizzle": "Çiseleme",
  "weatherConditions.flurries": "Hafif kar",
  "weatherConditions.foggy": "Sis",
  "weatherConditions.freezingDrizzle": "Dondurucu çiseleme",
  "weatherConditions.freezingRain": "Dondurucu yağmur",
  "weatherConditions.frigid": "Şiddetli soğuk",
  "weatherConditions.hail": "Dolu",
  "weatherConditions.haze": "Pus",
  "weatherConditions.heavyRain": "Şiddetli yağmur",
  "weatherConditions.heavySnow": "Yoğun kar yağışı",
  "weatherConditions.hot": "Sıcak",
  "weatherConditions.hurricane": "Kasırga",
  "weatherConditions.isolatedThunderstorms": "İzole gök gürültülü sağanaklar",
  "weatherConditions.mixedRainAndHail": "Yağmur ve dolu",
  "weatherConditions.mostlyClear": "Çoğunlukla açık",
  "weatherConditions.mostlyCloudy": "Çoğunlukla bulutlu",
  "weatherConditions.mostlySunny": "Çoğunlukla güneşli",
  "weatherConditions.notAvailable": "Hava durumu bilgisi mevcut değil",
  "weatherConditions.partlyCloudy": "Parçalı bulutlu",
  "weatherConditions.rain": "Yağmur",
  "weatherConditions.rainSleet": "Yağmur ve buz taneleri",
  "weatherConditions.rainSnow": "Karla karışık yağmur",
  "weatherConditions.scatteredShowers": "Yer yer sağanak yağış",
  "weatherConditions.scatteredSnowShowers": "Yer yer kar sağanağı",
  "weatherConditions.scatteredThunderstorms": "Yer yer gök gürültülü sağanak",
  "weatherConditions.showers": "Sağanak yağış",
  "weatherConditions.sleet": "Buz taneleri",
  "weatherConditions.smoke": "Duman",
  "weatherConditions.snow": "Kar",
  "weatherConditions.snowShowers": "Kar sağanağı",
  "weatherConditions.strongStorms": "Şiddetli gök gürültülü fırtına",
  "weatherConditions.sunny": "Güneşli",
  "weatherConditions.thunderstorms": "Gök gürültülü sağanak yağış",
  "weatherConditions.tornado": "Hortum",
  "weatherConditions.tropicalStorm": "Tropikal fırtına",
  "weatherConditions.windy": "Rüzgârlı",
  "weatherConditions.wintryMix": "Karışık kış yağışı"
}
